// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-10T20:07:08.533Z
// Property: Belmont (ID: 6767906449167740)
// Collections: 52 amenities, 9 floorplans (live), 56 photos, 75 POIs, 20 reviews, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5760613594693632",
  "multihub_property_id": "6767906449167740",
  "property_external_id": "z0v0vpw",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/the-mason-ladson-sc/z0v0vpw/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "belmont",
  "property_name": "Belmont",
  "property_website_url": "https://demo-premier-belmont.multiscreensite.com/",
  "property_domain": null,
  "property_address": "100 Peachtree St. N",
  "property_full_address": "100 Peachtree St. N",
  "property_address_1": "100 Peachtree St. N",
  "property_address_2": null,
  "property_address_city": "Ladson",
  "property_address_state": "SC",
  "property_address_zip_full": null,
  "property_address_zip": "29456",
  "property_address_country": "US",
  "property_address_county": "Charleston County",
  "property_neighborhood_address": "100 Peachtree St. N",
  "property_address_latitude": "32.9992435",
  "property_address_longitude": "-80.11861189999999",
  "property_email": null,
  "property_phone": "123-456-7890",
  "property_call_tracking_phone": null,
  "property_company_name": "Rebel Residential",
  "property_company_url": null,
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Brand-new luxury living.</strong> The Belmont offers pet-friendly studio, one, two, and three bedroom homes with polished finishes, everyday convenience, and curated spaces for modern downtime—schedule your tour today.</p>",
  "property_long_description": "<p>The Belmont offers brand-new studio, one, two, and three bedroom homes near Charleston Southern University. Our pet-friendly apartments feature high-end amenities to equip you for modern living, including chef-worthy kitchens finished with sleek stainless-steel appliances and granite countertops. Convenience is key here – focus less on chores and more on what you love – which is why each home has its own washer and dryer. We also prioritize self-care with our consciously curated amenities, including a 24-hour fitness center, resort-worthy swimming pool with cabanas, and clubhouse with cyber cafe. Leave basic behind when you upgrade to luxury living at The Belmont.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5d-04d8-741a-be69-91845fa5b677.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and an outdoor grilling area.",
    "public_id": "01a03e5d-04d8-741a-be69-91845fa5b677",
    "storage_key": "property/6767906449167740/01a03e5d-04d8-741a-be69-91845fa5b677.webp",
    "width": 2000,
    "height": 1332
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "264",
  "property_year_built": "2020",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.6969696969697",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": null,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": "375",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "We happily accept up to 2 pets per apartment home.",
  "property_pet_policy_description": "We happily accept up to 2 pets per apartment home. One-time non-refundable pet fee: $375 per pet. Monthly pet rent: $30 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-7a1d-72ce-b7bc-4df36bd1a476.webp",
  "property_primary_logo_media": {
    "alt_text": "The Belmont logo",
    "public_id": "01a03e59-7a1d-72ce-b7bc-4df36bd1a476",
    "storage_key": "property/6767906449167740/01a03e59-7a1d-72ce-b7bc-4df36bd1a476.webp",
    "width": 1920,
    "height": 590
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-7a1d-72ce-b7bc-4df36bd1a476.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Belmont logo",
    "public_id": "01a03e59-7a1d-72ce-b7bc-4df36bd1a476",
    "storage_key": "property/6767906449167740/01a03e59-7a1d-72ce-b7bc-4df36bd1a476.webp",
    "width": 1920,
    "height": 590
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-7a1d-72ce-b7bc-4df36bd1a476.webp",
  "property_icon_media": {
    "alt_text": "The Belmont logo",
    "public_id": "01a03e59-7a1d-72ce-b7bc-4df36bd1a476",
    "storage_key": "property/6767906449167740/01a03e59-7a1d-72ce-b7bc-4df36bd1a476.webp",
    "width": 1920,
    "height": 590
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5760613594693632/01a03915-19b6-71d4-aeb8-805d7480607e.webp",
  "property_fav_icon_media": {
    "alt_text": "RR logo",
    "public_id": "01a03915-19b6-71d4-aeb8-805d7480607e",
    "storage_key": "company/5760613594693632/01a03915-19b6-71d4-aeb8-805d7480607e.webp",
    "width": 2000,
    "height": 2000
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-787b-704d-ad08-cd37e1d9284e.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Belmont logo",
    "public_id": "01a03e59-787b-704d-ad08-cd37e1d9284e",
    "storage_key": "property/6767906449167740/01a03e59-787b-704d-ad08-cd37e1d9284e.webp",
    "width": 1920,
    "height": 701
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-7a1d-72ce-b7bc-4df36bd1a476.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Belmont logo",
    "public_id": "01a03e59-7a1d-72ce-b7bc-4df36bd1a476",
    "storage_key": "property/6767906449167740/01a03e59-7a1d-72ce-b7bc-4df36bd1a476.webp",
    "width": 1920,
    "height": 590
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5760613594693632/01a03915-19b6-71d4-aeb8-805d7480607e.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#95aaa1",
  "property_secondary_color": "#a4b6ae",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 3",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "603 - 1,331 sq ft",
  "property_sqft_min": "603",
  "property_sqft_max": "1,331",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 14,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJv2fJQmCK_ogR4SgTqiPfflU",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Belmont",
  "property_home_romance_title": "Embrace Life in Your Dream Apartment Community",
  "property_home_amenities_blurb": "<p><strong>Everyday ease, polished up.</strong> Belmont brings the extras into focus with a resort-style pool and cabanas, a clubhouse with coffee bar, media room, and lounge, plus a 24-hour fitness center for whenever the day opens up. Outdoor fireplace and grilling areas add room to unwind, while package service, door-to-door trash pickup, and a car wash station keep life moving. Inside, expect stainless steel appliances, granite countertops, in-home laundry, and walk-in closets.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find your fit at Belmont.</strong> Studio, one-, two-, and three-bedroom apartments offer open, easy-flowing layouts with polished finishes like granite countertops, stainless steel appliances, in-home laundry, walk-in closets, and ceiling fans. Select homes add a private balcony or patio, plus storage-smart details like pantries or linen closets. Explore featured floor plans, compare current options, and choose the space that feels right in the Summerville area.</p>",
  "property_home_gallery_blurb": "<p><strong>See Belmont in the best light.</strong> Preview granite-topped kitchens, open living rooms, balconies, pond views, and polished baths, then picture the community spaces beyond your door: a resort-style pool with cabanas, palms, lounge seating, and a fireplace-ready gathering area. Explore the full gallery for the clubhouse lounge, game room, fitness center, movie room, and courtyards that bring Lowcountry living into focus.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Summerville access with a quieter place to land.</strong> From Belmont, everyday Ladson convenience meets the local flavor of Nexton Square, downtown Main Street, Short Central, and Hutchinson Square—think coffee runs, patios, small shops, festivals, and Sweet Tea Trail stops. For fresh air, Sawmill Branch Trail adds paved miles for walking and biking, while nearby routes connect to shopping, employers, campuses, and the coast. Explore the map, then come home to Belmont’s pond-side setting.</p>",
  "property_home_reviews_blurb": "<p><strong>Service that stands out.</strong><br>Belmont reviews point to a leasing team that listens, responds, and follows through. April, Brooke, Keisha, and Jenna earn shoutouts for helpful communication, quick answers, and professional care. Residents and visitors also highlight the clean, modern setting, well-kept spaces, and standout amenities like the gorgeous pool. Read more to see the Belmont experience in their own words.</p>",
  "property_neighborhood_blurb": "<p><strong>Map out a Summerville-area routine with room to roam.</strong> From Belmont, you’re positioned between everyday Ladson convenience and the local flavor that makes Summerville worth exploring. Head toward Nexton Square for groceries, coffee, and a growing restaurant scene, or spend an afternoon around downtown’s Main Street, Short Central, and Hutchinson Square, where small shops, patios, festivals, and Sweet Tea Trail stops give the area its easygoing Lowcountry character.</p><p>When fresh air calls, the Sawmill Branch Trail offers miles of paved walking and biking, while nearby routes connect you to Charleston-area employers, campuses, shopping, and the coast beyond. Use the interactive map to find your next dinner spot, park stop, errand run, or weekend outing—then come back to Belmont’s quieter pond-side setting just outside the bustle.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that make the day run smoother.</strong> At Belmont, polished apartment finishes meet the shared spaces you’ll actually use—from a resort-style pool with cabanas to a clubhouse with coffee bar, media room, and game-ready lounge space. Fit a workout into your schedule in the 24-hour fitness center, unwind by the outdoor fireplace and grilling areas, or take advantage of everyday conveniences like package service, door-to-door trash pickup, and a car wash station.</p><p>Inside, your home keeps the same elevated rhythm with stainless steel appliances, granite countertops, in-home washer and dryer, walk-in closets, and select island kitchens, balconies, patios, and pond views. Browse the <a href=\"/gallery\">photo gallery</a> to picture the details, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Belmont’s amenity spaces in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to upgrade to brand-new living?</strong> Start your online application for The Mason and choose from studio, one, two, and three bedroom apartments with pet-friendly spaces, chef-worthy kitchens, in-home washer and dryer, and curated amenities designed for modern convenience.</p>",
  "property_contactus_blurb": "<p><strong>Have questions? We’re here to help.</strong> Contact The Mason leasing team for details on brand-new studio, one, two, and three bedroom homes, pet-friendly living, or <a href=\"/schedule-a-tour\">directions for your visit</a>. Reach out today and take the next step toward luxury living in Ladson.</p>",
  "property_faqs_blurb": "<p><strong>Questions about life at The Mason?</strong> Start here for quick answers on our pet-friendly community, leasing details, modern apartment features, and everyday conveniences. If you don’t see what you need, our leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the space that matches your routine.</strong> At Belmont, studio, one-, two-, and three-bedroom floor plans give you options for everything from a streamlined retreat to a more expansive home with room to spread out. Open living areas keep the flow easy, while select layouts add a private balcony or patio for a little fresh-air space.</p><p>Inside, everyday details feel polished and practical: granite countertops, stainless steel appliances, in-home washer and dryer, walk-in closets, ceiling fans, and storage-friendly touches like pantries or linen closets in select homes. Browse current availability, compare layouts and pricing, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see which Summerville-area apartment feels right in person.</p>",
  "property_gallery_blurb": "<p><strong>Let the photos set the scene.</strong> Browse Belmont’s gallery to move from granite-topped kitchens and open living rooms to balconies, pond views, and outdoor spaces made for easy Lowcountry downtime. Notice the details up close: stainless steel appliances, island seating, soft natural light, and bathrooms with a polished finish. Then step into the community side of the collection, where the <a href=\"/amenities\">resort-style pool</a> brings together cabanas, lounge chairs, palms, and a fireplace-ready gathering area. You’ll also catch the clubhouse lounge, game room, fitness center, movie room, and courtyards that give each photo a fuller sense of life in the Summerville area. When a space catches your eye, <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Find your place at The Mason.</strong> Use the interactive map to explore brand-new studio, one, two, and three bedroom apartments in Ladson near Charleston Southern University, then see how the surrounding area connects to everyday convenience and modern living.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, zoomies, and easy daily routines.</strong> At Belmont, your pet-friendly apartment extends beyond the front door with a dedicated pet play area, walking and biking trails, and courtyard green space for quick fresh-air breaks.</p><p>Back at home, practical finishes like in-home washer/dryer, walk-in closets, and easy-care vinyl flooring help keep everyday life with pets simple, while select balconies, patios, and pond views add a calm perch between walks. When you want to see how it all fits, explore the community’s <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to find your next Summerville routine with your companion in mind.</p>",
  "property_referafriend_blurb": "<p><strong>Share the luxury living you love.</strong> Invite a friend to discover brand-new homes with chef-worthy kitchens, in-home washers and dryers, and curated spaces made for modern convenience and self-care. Send your referral today and help them upgrade life at The Mason.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at The Mason</strong><br>Convenience is key—pay rent, submit maintenance requests, and manage your account online with ease. Spend less time on to-dos and more time enjoying modern living in your pet-friendly Ladson apartment home.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback, real service.</strong><br>As you read through Belmont reviews, you’ll see a clear theme: people appreciate a leasing team that listens, responds, and follows through. Reviewers call out April, Brooke, Keisha, and Jenna for being “super helpful and responsive,” answering questions, returning calls and emails, and handling situations with professionalism and care. You’ll also hear positive impressions of a clean, modern community with well-kept spaces and standout amenities, including a gorgeous pool. Browse the comments to see how the experience at Belmont feels from the people who have toured, applied, and made their home here.</p>",
  "property_created_at": "1787752406372",
  "property_scheduletour_blurb": "<p><strong>See luxury living come to life.</strong> Tour brand-new studio, one, two, and three bedroom homes with chef-worthy kitchens, stainless-steel appliances, granite countertops, and in-home washers and dryers. Then get a closer look at the pool, cabanas, fitness center, and clubhouse. Schedule your visit to The Mason today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — we’ve received your inquiry.</strong><br>Our leasing team will be in touch soon. In the meantime, picture brand-new studio, one, two, and three bedroom apartments with pet-friendly living, chef-worthy kitchens, in-home washers and dryers, and curated amenities designed for everyday ease.</p>",
  "property_virtualtours_blurb": "<p><strong>Start with a walk-through, not a guess.</strong> Belmont’s virtual tours let you move through key spaces before you visit, from a 2-bedroom, 2-bath apartment to the community areas that shape everyday downtime. Explore the apartment layout to picture room-to-room flow, kitchen finishes, storage, and natural light, then step into the fitness center, clubhouse, movie theater room, and Pool 360 tour for a closer look at the shared spaces featured in the <a href=\"/amenities\">amenities</a>. Use the community virtual tour for a broader feel of the property, compare options on the <a href=\"/floor-plans\">floor plans</a> page, and when you’re ready for the real thing, <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_copyright": "2026 All Rights Reserved. Belmont",
  "property_seo_title_home": "Belmont |  Apartments in Ladson, SC",
  "property_seo_description_home": "Experience modern living at Belmont in Ladson, SC. Enjoy spacious floor plans, top-notch amenities, and a vibrant community. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Ladson, SC Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Belmont in Ladson, SC! Choose from stylish one, two, or three-bedroom floor plans. Browse now to uncover your perfect home!",
  "property_seo_title_amenities": "Amenities | Ladson, SC Apartments for Rent",
  "property_seo_description_amenities": "Discover luxury living at Belmont in Ladson, SC! Enjoy premium amenities, a state-of-the-art fitness center, and peaceful walking trails.",
  "property_seo_title_gallery": "Gallery | Apartments in Ladson, SC",
  "property_seo_description_gallery": "Experience the charm of Belmont in Ladson, SC! From scenic views to top-tier amenities, envision your new home among our stunning photo gallery!",
  "property_seo_title_virtualtours": "Virtual Tours | Belmont Apartments",
  "property_seo_description_virtualtours": "Experience Belmont in Ladson, SC! Take a virtual tour of our stylish one, two, and three-bedroom apartments. Your perfect home awaits—step inside today!",
  "property_seo_title_interactivemap": "Interactive Map | Belmont Apartments",
  "property_seo_description_interactivemap": "Uncover your perfect apartment at Belmont in Ladson, SC! Use our interactive map to find stunning one, two, and three-bedroom homes with top-notch amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Ladson, SC",
  "property_seo_description_neighborhood": "Experience the vibrant Ladson lifestyle at Belmont! Uncover local favorites, charming spots, and everything our diverse neighborhood has to offer.",
  "property_seo_title_contact": "Contact Us | Belmont",
  "property_seo_description_contact": "Experience the perfect blend of comfort and style at Belmont in Ladson, SC. Questions? Our leasing team is here to help you find your ideal home!",
  "property_seo_title_faqs": "FAQs | Apartments in Ladson, SC",
  "property_seo_description_faqs": "Get all your questions answered at Belmont in Ladson, SC! Our FAQs page covers everything you need to know about amenities, floor plans, and more.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Ladson, SC",
  "property_seo_description_reviews": "Experience the charm of Belmont in Ladson, SC! Our residents share their stories of comfort, community, and stylish living. Join us and feel at home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Ladson, SC",
  "property_seo_description_applynow": "Experience modern living at Belmont in Ladson, SC. Choose from spacious one, two, or three-bedroom apartments with top-notch amenities. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Belmont",
  "property_seo_description_residentaccess": "Belmont residents in Ladson, SC can simplify life! Log in now to pay rent, request maintenance, and stay updated on community news at your fingertips.",
  "property_seo_title_referafriend": "Refer A Friend | Belmont",
  "property_seo_description_referafriend": "Great friends make great neighbors at Belmont! Refer a friend today and enjoy a vibrant community in Ladson, SC. Together, let’s create lasting memories!",
  "property_seo_title_scheduletour": "Schedule a Tour | Belmont",
  "property_seo_description_scheduletour": "Experience modern living at Belmont in Ladson, SC. Schedule a tour today and see why our community is the perfect place to call home!",
  "property_seo_title_privacy": "Privacy Policy | Belmont",
  "property_seo_description_privacy": "Your privacy matters at Belmont in Ladson, SC. Dive into our privacy policy to see how we protect your information and ensure a secure living experience.",
  "property_seo_title_accessibility": "Website Accessibility | Belmont",
  "property_seo_description_accessibility": "At Belmont in Ladson, SC, we prioritize accessibility for all. Join our welcoming community where everyone can thrive. Your comfort is our mission!",
  "property_seo_title_sitemap": "Sitemap | Belmont",
  "property_seo_description_sitemap": "Uncover Belmont in Ladson, SC! Navigate our sitemap to find your perfect home, vibrant community, and all the amenities waiting for you.",
  "property_seo_title_thankyou": "Thank You | Belmont",
  "property_seo_description_thankyou": "Thank you for reaching out! A Belmont team member will connect with you soon to help you find your perfect home in beautiful Ladson, SC. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Ladson, SC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1789048637093",
  "amenities": [
    {
      "id": "ec_94e49989e0657fdba28fa6a3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Concierge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da33c4783828ab911c7fec5f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8f86d72e43ef77d726e15e54",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Car Wash Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1528d1ea92eea95332d5efcd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Package Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0be45991c2306b1f4de592da",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Play Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b082cd52dc7826f8841499e5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Planned Social Activities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_935622932b7a83076ebcd681",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Trash Pickup - Door to Door",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ae37ff7afc480ee65734dcbd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_46356a42b462a8fe3b5057ad",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Maintenance on site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_06d222ce6d9c5839901b7083",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3d214e130c54774332b67f8a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Breakfast/Coffee Concierge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8bf12ec09ff0873a0ba0c285",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Storage Space",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9bc852a1d5dfb1b8a6bea904",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_50d133b258c2c55a131b14e3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-Up",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_45775c8d3a1d09a241a9c2bc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a49fc1f47cd2e7aba3ad6335",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f0471c77d2773435cdf67ade",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Cabana",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1cf5c51917d471a1996194f1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Grill",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab258cffbc9b59f26d16e2b4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Pond",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b2b6eebe62db780e67e90bfc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0690a7b8e1f399d82abdd6c1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c8a7970e82b512a98cdfdf43",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ce8e0a9466493c51fb2dcfd0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Gameroom",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_634b29a7d6523976c73938b8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Media Center/Movie Theatre",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e5454d1e7a5bdae7343953e6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Walking/Biking Trails",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3c7c6ad5990c3f3cb0790f3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c8a1374dd66209cb1ddc03c3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Storage Space",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f16085cc88345cc46826b5a8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_02fd6965d58199ec02b6653c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff8dd91bf3f126cf35be09fe",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Double Vanities",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_41c79f5717bd74fa39dc3297",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Tub/Shower",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc4319c99b27ebd6ee0d211f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2036b8d8862b7a2f348ecf6c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4a9cc7139b5e50f207eb882e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f91f019e2a10a5214b678721",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_926955b6dd702d9633275c0d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d03ced0237f946134a7ff98",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Ice Maker",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eb520854a453f8141564be1e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9569d5d63188ecdc4354b940",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Oven",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7556ab57a135cf01571c7468",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a68a7c5c94f8cdd03d18d6a4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00e8a9bd1718f80c6c29863b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Island Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_513ca6f990474da6f79ad69f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f0710c71317d9f8f810ca77",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Crown Molding",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4feedd8550cd75214c964d28",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6c57f996cbd9d8a905dd27f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad0ba971d344696cc34ae445",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Carpet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_218f8bb1c8c93d385b6b89b9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e9580b0d9246fdfb01a77392",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Linen Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_943dc2fc79b37ee0eeb60cd6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Vinyl Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d3a4dfd345928ed84807aa03",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ccbbacc935879ca4f42aaf5a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "apartments",
      "external_id": "false",
      "title": "Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_72fad0f0-1e98-4ce4-a3bd-a4250b7697e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5d-04d8-741a-be69-91845fa5b677.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and an outdoor grilling area.",
        "public_id": "01a03e5d-04d8-741a-be69-91845fa5b677",
        "storage_key": "property/6767906449167740/01a03e5d-04d8-741a-be69-91845fa5b677.webp",
        "width": 2000,
        "height": 1332
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool, complete with ample lounge seating and an outdoor grilling area for resident use.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and an outdoor grilling area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_41e7a364-e623-4abf-95b9-901c31ef930a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-fb91-76d4-b70e-1418f2bf2bc7.webp",
      "image_media": {
        "alt_text": "Bathroom with granite vanity, large mirror, toilet, and bathtub with shower curtain.",
        "public_id": "01a03e5c-fb91-76d4-b70e-1418f2bf2bc7",
        "storage_key": "property/6767906449167740/01a03e5c-fb91-76d4-b70e-1418f2bf2bc7.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy the modern comforts of this well-appointed bathroom, featuring a spacious vanity, ample mirror, and a relaxing bathtub.",
      "link": "",
      "alt_text": "Bathroom with granite vanity, large mirror, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7305eb93-aa52-4b90-b2f2-c19af97bd3e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-f78b-7495-84f0-a95a8b5774a1.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with covered cabanas and lounge chairs.",
        "public_id": "01a03e5c-f78b-7495-84f0-a95a8b5774a1",
        "storage_key": "property/6767906449167740/01a03e5c-f78b-7495-84f0-a95a8b5774a1.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax in style in our outdoor lounge area, featuring private cabanas and comfortable lounge chairs perfect for soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor lounge area with covered cabanas and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9813340d-e5e4-4ab1-b2f4-a4403feb4248",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-f020-70a2-9111-544259da2f8d.webp",
      "image_media": {
        "alt_text": "Bedroom with a canopy bed, dresser, and ceiling fan.",
        "public_id": "01a03e5c-f020-70a2-9111-544259da2f8d",
        "storage_key": "property/6767906449167740/01a03e5c-f020-70a2-9111-544259da2f8d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a modern canopy bed, a wooden dresser with a mirror, and a ceiling fan, creating a comfortable and stylish living space.",
      "link": "",
      "alt_text": "Bedroom with a canopy bed, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bc2cdaef-8aca-43ca-b8b8-d0fc25b80e1b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-ec76-735b-b63a-047e513296d1.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower with curtain",
        "public_id": "01a03e5c-ec76-735b-b63a-047e513296d1",
        "storage_key": "property/6767906449167740/01a03e5c-ec76-735b-b63a-047e513296d1.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A well-lit bathroom featuring a granite-top vanity with a silver-framed mirror, a toilet, and a shower with a decorative curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and shower with curtain",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_21dfeb47-6da0-414f-bece-27949492bb07",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-dcf2-75a8-a552-ecc442300d68.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, decorative pillows, nightstands, and a ceiling fan.",
        "public_id": "01a03e5c-dcf2-75a8-a552-ecc442300d68",
        "storage_key": "property/6767906449167740/01a03e5c-dcf2-75a8-a552-ecc442300d68.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A cozy bedroom featuring a queen-size bed with plush pillows and a decorative throw, flanked by elegant nightstands. A ceiling fan provides comfort.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, decorative pillows, nightstands, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d8f90be7-b437-48ad-8d68-dcba68d49cef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-daab-765a-a582-246291a9dbb4.webp",
      "image_media": {
        "alt_text": "Modern dining and living room with kitchen island, stainless steel appliances, and patio doors.",
        "public_id": "01a03e5c-daab-765a-a582-246291a9dbb4",
        "storage_key": "property/6767906449167740/01a03e5c-daab-765a-a582-246291a9dbb4.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a modern kitchen with island, elegant dining space, and comfortable living room with access to the patio.",
      "link": "",
      "alt_text": "Modern dining and living room with kitchen island, stainless steel appliances, and patio doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e1c05d3c-9874-4d8a-b876-27355d6d8292",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-d408-72bd-af9c-f818d8a15145.webp",
      "image_media": {
        "alt_text": "Bright and airy living room with a large sofa, accent chairs, coffee table, and a view into a bedroom.",
        "public_id": "01a03e5c-d408-72bd-af9c-f818d8a15145",
        "storage_key": "property/6767906449167740/01a03e5c-d408-72bd-af9c-f818d8a15145.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living room featuring comfortable seating and elegant decor, with an adjacent bedroom for convenience and privacy.",
      "link": "",
      "alt_text": "Bright and airy living room with a large sofa, accent chairs, coffee table, and a view into a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a359d287-d4a8-490e-b914-fd11ed187080",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-d22b-70eb-a655-676cbc75f156.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light gray cabinets, granite countertops, stainless steel appliances, and a central island with bar stools.",
        "public_id": "01a03e5c-d22b-70eb-a655-676cbc75f156",
        "storage_key": "property/6767906449167740/01a03e5c-d22b-70eb-a655-676cbc75f156.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment kitchen featuring elegant gray cabinetry, granite countertops, and a convenient island perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with light gray cabinets, granite countertops, stainless steel appliances, and a central island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5e044b0e-4fb9-4d48-b56c-48d4512e7146",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-cbe1-7233-bddf-be47c9ec4e7f.webp",
      "image_media": {
        "alt_text": "Outdoor pet grooming station with a hose and sink.",
        "public_id": "01a03e5c-cbe1-7233-bddf-be47c9ec4e7f",
        "storage_key": "property/6767906449167740/01a03e5c-cbe1-7233-bddf-be47c9ec4e7f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Convenient outdoor pet grooming station with a high-pressure hose and built-in sink, perfect for keeping your furry friends clean.",
      "link": "",
      "alt_text": "Outdoor pet grooming station with a hose and sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ab2d580b-4462-4d7a-bf4b-e19fca48d24a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-bf3a-726c-b37f-d107446d5681.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, parking lots, and a pond.",
        "public_id": "01a03e5c-bf3a-726c-b37f-d107446d5681",
        "storage_key": "property/6767906449167740/01a03e5c-bf3a-726c-b37f-d107446d5681.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing the amenities and layout of this modern apartment community, featuring well-maintained buildings, ample parking, and a serene pond.",
      "link": "",
      "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, parking lots, and a pond.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_03503890-908b-424b-bfea-95a010abd0bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-b847-7649-b3de-e4e5edf92829.webp",
      "image_media": {
        "alt_text": "Fenced-in grassy area with trees and a dog waste station.",
        "public_id": "01a03e5c-b847-7649-b3de-e4e5edf92829",
        "storage_key": "property/6767906449167740/01a03e5c-b847-7649-b3de-e4e5edf92829.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy the fresh air and open space in our community's fenced-in yard, complete with a convenient dog waste station for your furry friends.",
      "link": "",
      "alt_text": "Fenced-in grassy area with trees and a dog waste station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d30543c5-e6a0-4006-800b-fa4adf0ce8ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-b02f-76d5-93c4-406981a8e038.webp",
      "image_media": {
        "alt_text": "Car wash station with vacuums and bays",
        "public_id": "01a03e5c-b02f-76d5-93c4-406981a8e038",
        "storage_key": "property/6767906449167740/01a03e5c-b02f-76d5-93c4-406981a8e038.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Convenient car wash station for residents, featuring vacuum cleaners and covered bays. Keep your vehicle sparkling clean.",
      "link": "",
      "alt_text": "Car wash station with vacuums and bays",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_60d3a989-2003-4f0e-a837-e83985b10d81",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-aaad-75b4-9b64-54e461a00dba.webp",
      "image_media": {
        "alt_text": "Covered outdoor grilling area with a built-in grill, brick fireplace, and seating.",
        "public_id": "01a03e5c-aaad-75b4-9b64-54e461a00dba",
        "storage_key": "property/6767906449167740/01a03e5c-aaad-75b4-9b64-54e461a00dba.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy outdoor living with this communal grilling station, complete with a full-size grill and a cozy fireplace, perfect for gatherings.",
      "link": "",
      "alt_text": "Covered outdoor grilling area with a built-in grill, brick fireplace, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2f68458d-bc39-475a-ad11-c9612fde3fe8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-a079-7253-a438-d86271bf96c4.webp",
      "image_media": {
        "alt_text": "Outdoor fitness area with monkey bars, punching bag, and benches under a shade sail.",
        "public_id": "01a03e5c-a079-7253-a438-d86271bf96c4",
        "storage_key": "property/6767906449167740/01a03e5c-a079-7253-a438-d86271bf96c4.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active at our state-of-the-art outdoor fitness area, complete with monkey bars, a punching bag, and workout benches, all shaded for your comfort.",
      "link": "",
      "alt_text": "Outdoor fitness area with monkey bars, punching bag, and benches under a shade sail.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_07db603e-c9d3-48e2-8d85-44c841fdc9ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-8e71-77c2-8d40-0fbd27eb714a.webp",
      "image_media": {
        "alt_text": "Outdoor game area with bocce ball courts and a playground in the background.",
        "public_id": "01a03e5c-8e71-77c2-8d40-0fbd27eb714a",
        "storage_key": "property/6767906449167740/01a03e5c-8e71-77c2-8d40-0fbd27eb714a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation with our bocce ball courts and a playground for all ages. Perfect for relaxing and having fun in the community courtyard.",
      "link": "",
      "alt_text": "Outdoor game area with bocce ball courts and a playground in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2b13d7e2-5c2f-4d05-8269-ef93319fdb4b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-8b71-729f-a981-daf64ee2130d.webp",
      "image_media": {
        "alt_text": "Playground equipment with slides and climbing structures outside apartment buildings.",
        "public_id": "01a03e5c-8b71-729f-a981-daf64ee2130d",
        "storage_key": "property/6767906449167740/01a03e5c-8b71-729f-a981-daf64ee2130d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring slides, climbing walls, and swings for all ages.",
      "link": "",
      "alt_text": "Playground equipment with slides and climbing structures outside apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_606873f1-ee24-4000-a19c-0238bb164d48",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-8594-77e9-8d6d-00794297deed.webp",
      "image_media": {
        "alt_text": "Outdoor fire pit with seating and lounge chairs near a swimming pool and apartment buildings.",
        "public_id": "01a03e5c-8594-77e9-8d6d-00794297deed",
        "storage_key": "property/6767906449167740/01a03e5c-8594-77e9-8d6d-00794297deed.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy relaxing evenings around the fire pit, with comfortable seating and lounge chairs available. The sparkling swimming pool and scenic apartment buildings create a perfect ambiance.",
      "link": "",
      "alt_text": "Outdoor fire pit with seating and lounge chairs near a swimming pool and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fc28bec1-e190-4294-b1b3-b536c57ba2b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-7f2d-7048-984c-8be211cd0290.webp",
      "image_media": {
        "alt_text": "Swimming pool with built-in chaise lounges and lounge chairs.",
        "public_id": "01a03e5c-7f2d-7048-984c-8be211cd0290",
        "storage_key": "property/6767906449167740/01a03e5c-7f2d-7048-984c-8be211cd0290.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with comfortable built-in chaise lounges and ample seating for relaxation.",
      "link": "",
      "alt_text": "Swimming pool with built-in chaise lounges and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2916c086-30b9-473d-b59d-47f385305f52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-7bd7-713d-9a22-930ed3069588.webp",
      "image_media": {
        "alt_text": "Covered lounge areas with chaise lounges at a multifamily property.",
        "public_id": "01a03e5c-7bd7-713d-9a22-930ed3069588",
        "storage_key": "property/6767906449167740/01a03e5c-7bd7-713d-9a22-930ed3069588.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish, covered lounge areas, perfect for soaking up the sun or enjoying a quiet afternoon.",
      "link": "",
      "alt_text": "Covered lounge areas with chaise lounges at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a050aeba-9311-4876-8c44-a8fbf80c2ff0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-6638-72cc-b212-0330402a2236.webp",
      "image_media": {
        "alt_text": "Resort-style outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "01a03e5c-6638-72cc-b212-0330402a2236",
        "storage_key": "property/6767906449167740/01a03e5c-6638-72cc-b212-0330402a2236.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, surrounded by comfortable lounge chairs and the beautiful architecture of our community.",
      "link": "",
      "alt_text": "Resort-style outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d87485ce-0bbd-4201-8918-57816320f82b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-61e7-756d-9a0f-91a70d05600e.webp",
      "image_media": {
        "alt_text": "Foosball table and shuffleboard in community game room",
        "public_id": "01a03e5c-61e7-756d-9a0f-91a70d05600e",
        "storage_key": "property/6767906449167740/01a03e5c-61e7-756d-9a0f-91a70d05600e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy fun and games in the community game room, featuring a foosball table and shuffleboard.",
      "link": "",
      "alt_text": "Foosball table and shuffleboard in community game room",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e5b38ad4-3c9a-4cba-ab21-2a6f8d406219",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-5cd1-731b-b80c-030bb4fb3eac.webp",
      "image_media": {
        "alt_text": "Spacious fitness center with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "01a03e5c-5cd1-731b-b80c-030bb4fb3eac",
        "storage_key": "property/6767906449167740/01a03e5c-5cd1-731b-b80c-030bb4fb3eac.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Spacious fitness center with treadmills, ellipticals, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e5dc35fe-e49d-4da6-ab57-466e02c1563a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-57fa-70ea-9bb4-528b1f126147.webp",
      "image_media": {
        "alt_text": "Interior view of the apartment fitness center with spin bikes and yoga mats.",
        "public_id": "01a03e5c-57fa-70ea-9bb4-528b1f126147",
        "storage_key": "property/6767906449167740/01a03e5c-57fa-70ea-9bb4-528b1f126147.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with spin bikes, free weights, and space for yoga and stretching.",
      "link": "",
      "alt_text": "Interior view of the apartment fitness center with spin bikes and yoga mats.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c44a731b-9769-4ef7-a7c6-aa5002c441d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-59ac-767d-a74e-34f2aad78fdc.webp",
      "image_media": {
        "alt_text": "Home theater room with a projector and screen, bar, and seating.",
        "public_id": "01a03e5c-59ac-767d-a74e-34f2aad78fdc",
        "storage_key": "property/6767906449167740/01a03e5c-59ac-767d-a74e-34f2aad78fdc.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy movie nights in the community's home theater, featuring a projector, screen, bar, and comfortable seating.",
      "link": "",
      "alt_text": "Home theater room with a projector and screen, bar, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e670ddfd-5ad5-4b2b-a0aa-e78c55f9d2bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-4820-77be-b491-36c3171335a4.webp",
      "image_media": {
        "alt_text": "Community lounge with shuffleboard and foosball tables, seating area, and large windows.",
        "public_id": "01a03e5c-4820-77be-b491-36c3171335a4",
        "storage_key": "property/6767906449167740/01a03e5c-4820-77be-b491-36c3171335a4.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy friendly competition and relaxation in our vibrant community lounge, featuring shuffleboard and foosball tables, comfortable seating, and ample natural light.",
      "link": "",
      "alt_text": "Community lounge with shuffleboard and foosball tables, seating area, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_31974362-e843-4f2d-af64-a3ed71a62585",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-39d5-744a-b3ef-56c0bc45caa5.webp",
      "image_media": {
        "alt_text": "Clubhouse common area with large dining table and lounge seating.",
        "public_id": "01a03e5c-39d5-744a-b3ef-56c0bc45caa5",
        "storage_key": "property/6767906449167740/01a03e5c-39d5-744a-b3ef-56c0bc45caa5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy the spacious clubhouse, featuring a large dining table and comfortable lounge seating perfect for socializing or relaxing.",
      "link": "",
      "alt_text": "Clubhouse common area with large dining table and lounge seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_43dd8e52-029b-4174-8a02-9552de6fc3b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-3492-7698-81fa-f67e0ca9520a.webp",
      "image_media": {
        "alt_text": "Clubhouse living area with fireplace, seating, and coffee bar.",
        "public_id": "01a03e5c-3492-7698-81fa-f67e0ca9520a",
        "storage_key": "property/6767906449167740/01a03e5c-3492-7698-81fa-f67e0ca9520a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed clubhouse, featuring a cozy fireplace, ample seating, and a convenient coffee bar for your enjoyment.",
      "link": "",
      "alt_text": "Clubhouse living area with fireplace, seating, and coffee bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7a299a94-c460-471e-9c7c-3511076004da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-32bd-70ce-b1b6-2cdacd75c39f.webp",
      "image_media": {
        "alt_text": "Exterior entrance to apartment building with white siding and blue shutters.",
        "public_id": "01a03e5c-32bd-70ce-b1b6-2cdacd75c39f",
        "storage_key": "property/6767906449167740/01a03e5c-32bd-70ce-b1b6-2cdacd75c39f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "View of the exterior entrance and side of an apartment building, featuring white siding, balconies, and landscaping.",
      "link": "",
      "alt_text": "Exterior entrance to apartment building with white siding and blue shutters.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_760b80ef-10e4-4c6c-abe1-175eedaf0e13",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-2ea9-745c-9d2f-a3ccca64673a.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and blue shutters.",
        "public_id": "01a03e5c-2ea9-745c-9d2f-a3ccca64673a",
        "storage_key": "property/6767906449167740/01a03e5c-2ea9-745c-9d2f-a3ccca64673a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Showcasing the beautiful exterior of the apartment building, featuring private balconies and charming blue shutters.",
      "link": "",
      "alt_text": "Exterior view of a multi-story apartment building with balconies and blue shutters.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7538d10a-d09e-4e12-bef9-5791c20e06c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-2904-721d-a235-ab0a733c7641.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and palm trees.",
        "public_id": "01a03e5c-2904-721d-a235-ab0a733c7641",
        "storage_key": "property/6767906449167740/01a03e5c-2904-721d-a235-ab0a733c7641.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Captivating exterior shot of the apartment building, showcasing its modern design, private balconies, and lush surrounding landscape.",
      "link": "",
      "alt_text": "Exterior view of a multi-story apartment building with balconies and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bf40b7cc-1a2e-45bb-86cb-d5ecf66c9e75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-1cbd-7754-ba11-e1aa17014c86.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and walkways.",
        "public_id": "01a03e5c-1cbd-7754-ba11-e1aa17014c86",
        "storage_key": "property/6767906449167740/01a03e5c-1cbd-7754-ba11-e1aa17014c86.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring multiple levels, private balconies, and well-maintained landscaping.",
      "link": "",
      "alt_text": "Exterior view of a multi-story apartment building with balconies and walkways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b53d3795-3547-4611-9d06-b6975dcc679a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-17c7-72b1-8541-c7e96119042b.webp",
      "image_media": {
        "alt_text": "Apartment complex with green courtyards and playgrounds.",
        "public_id": "01a03e5c-17c7-72b1-8541-c7e96119042b",
        "storage_key": "property/6767906449167740/01a03e5c-17c7-72b1-8541-c7e96119042b.webp",
        "width": 2000,
        "height": 1332
      },
      "title": "Community",
      "description": "Enjoy the spacious courtyards and playgrounds at this apartment complex, perfect for outdoor activities and relaxation.",
      "link": "",
      "alt_text": "Apartment complex with green courtyards and playgrounds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_630f8345-ac52-4b58-bcfe-1868a8c61ded",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-1092-705c-b8da-66b8ca3bedb2.webp",
      "image_media": {
        "alt_text": "Fitness center with spin bikes, free weights, yoga mats, and a large mirror.",
        "public_id": "01a03e5c-1092-705c-b8da-66b8ca3bedb2",
        "storage_key": "property/6767906449167740/01a03e5c-1092-705c-b8da-66b8ca3bedb2.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy a workout in our state-of-the-art fitness center, featuring cardio machines, free weights, and yoga equipment.",
      "link": "",
      "alt_text": "Fitness center with spin bikes, free weights, yoga mats, and a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ff4d675e-4c97-4f00-ba36-bf56b48bc382",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-0a02-751b-ab4d-216561840ca1.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-sized bed, decorative pillows, and blue and white patterned curtains.",
        "public_id": "01a03e5c-0a02-751b-ab4d-216561840ca1",
        "storage_key": "property/6767906449167740/01a03e5c-0a02-751b-ab4d-216561840ca1.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom, featuring a plush queen-sized bed and elegant decor. Enjoy natural light filtering through the stylish curtains.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-sized bed, decorative pillows, and blue and white patterned curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_db75c2bc-667b-4b20-9490-03aa51e6e142",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-0492-77fe-97fd-ffa62d094f4c.webp",
      "image_media": {
        "alt_text": "Living room and bedroom of a furnished apartment with a couch, chairs, coffee table, and bed.",
        "public_id": "01a03e5c-0492-77fe-97fd-ffa62d094f4c",
        "storage_key": "property/6767906449167740/01a03e5c-0492-77fe-97fd-ffa62d094f4c.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this beautifully furnished apartment, featuring a spacious living room and a cozy bedroom.",
      "link": "",
      "alt_text": "Living room and bedroom of a furnished apartment with a couch, chairs, coffee table, and bed.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_befffbc0-6409-4fd3-9f6e-7eb7f45ad9cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5c-031e-72aa-b573-08545a66ca18.webp",
      "image_media": {
        "alt_text": "Home theater room with projector screen, comfortable seating, and audio equipment.",
        "public_id": "01a03e5c-031e-72aa-b573-08545a66ca18",
        "storage_key": "property/6767906449167740/01a03e5c-031e-72aa-b573-08545a66ca18.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy movie nights in our state-of-the-art home theater room, featuring a large screen, surround sound, and plush seating.",
      "link": "",
      "alt_text": "Home theater room with projector screen, comfortable seating, and audio equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1c244938-0dea-4231-9320-c808509d3333",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-f7ea-70c8-9c78-2d06550ca12d.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a03e5b-f7ea-70c8-9c78-2d06550ca12d",
        "storage_key": "property/6767906449167740/01a03e5b-f7ea-70c8-9c78-2d06550ca12d.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our stunning resort-style swimming pool, complete with comfortable lounge chairs and beautiful surrounding apartment buildings.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bd2a0a6e-6a76-49dc-9ba6-96f25b9fb216",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-f03f-742f-b51a-800901884803.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and a walk-in pantry.",
        "public_id": "01a03e5b-f03f-742f-b51a-800901884803",
        "storage_key": "property/6767906449167740/01a03e5b-f03f-742f-b51a-800901884803.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Stylish and functional kitchen featuring stainless steel appliances, ample counter space, and a convenient walk-in pantry for all your storage needs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and a walk-in pantry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7d717558-7e6b-4f0f-bad8-0148828651b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-e81c-7382-9df7-a003f665cbb1.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with couch and two geometric tables, overlooking a grassy courtyard and apartment buildings.",
        "public_id": "01a03e5b-e81c-7382-9df7-a003f665cbb1",
        "storage_key": "property/6767906449167740/01a03e5b-e81c-7382-9df7-a003f665cbb1.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Relax on your private balcony or patio, complete with comfortable seating and picturesque views of the community grounds and apartment buildings.",
      "link": "",
      "alt_text": "Outdoor seating area with couch and two geometric tables, overlooking a grassy courtyard and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e4cb9ca7-9e49-491d-96e8-a92c44c40034",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-e6f1-757b-b264-d19bdc3e8a76.webp",
      "image_media": {
        "alt_text": "Lounge chairs by the pool at the apartment complex.",
        "public_id": "01a03e5b-e6f1-757b-b264-d19bdc3e8a76",
        "storage_key": "property/6767906449167740/01a03e5b-e6f1-757b-b264-d19bdc3e8a76.webp",
        "width": 1680,
        "height": 1120
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling pool, complete with comfortable lounge chairs and serene views.",
      "link": "",
      "alt_text": "Lounge chairs by the pool at the apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4127b957-1f6b-493d-b61c-1f1a6fe3ba90",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-dde3-722b-80ee-5b0b8fd8adc8.webp",
      "image_media": {
        "alt_text": "Modern community lounge with shuffleboard, foosball, seating areas and a view of the pool.",
        "public_id": "01a03e5b-dde3-722b-80ee-5b0b8fd8adc8",
        "storage_key": "property/6767906449167740/01a03e5b-dde3-722b-80ee-5b0b8fd8adc8.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy leisure time in our spacious community lounge, complete with games like shuffleboard and foosball, comfortable seating, and a refreshing view of the outdoor pool.",
      "link": "",
      "alt_text": "Modern community lounge with shuffleboard, foosball, seating areas and a view of the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_951e1940-10df-4685-8a36-ec31a32e52e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-dd60-709e-9edc-9a03ea027942.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a granite countertop vanity, a white toilet, and a bathtub with a shower curtain.",
        "public_id": "01a03e5b-dd60-709e-9edc-9a03ea027942",
        "storage_key": "property/6767906449167740/01a03e5b-dd60-709e-9edc-9a03ea027942.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Stylish bathroom featuring a sleek vanity with a granite countertop, a comfortable bathtub, and modern fixtures. Perfect for unwinding.",
      "link": "",
      "alt_text": "Modern bathroom with a granite countertop vanity, a white toilet, and a bathtub with a shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_49969025-6939-4929-b14e-d233bda836b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-d767-7031-a369-998632acb859.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and walk-in closet with shelving and hanging storage.",
        "public_id": "01a03e5b-d767-7031-a369-998632acb859",
        "storage_key": "property/6767906449167740/01a03e5b-d767-7031-a369-998632acb859.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of a well-appointed bathroom featuring a sleek vanity and a spacious walk-in closet with ample storage for all your needs.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and walk-in closet with shelving and hanging storage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_34253294-6a70-4d3e-9866-bd3dd3d01b8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-d311-700d-b6a2-a060d1df0ef6.webp",
      "image_media": {
        "alt_text": "Washer and dryer appliances in a laundry closet.",
        "public_id": "01a03e5b-d311-700d-b6a2-a060d1df0ef6",
        "storage_key": "property/6767906449167740/01a03e5b-d311-700d-b6a2-a060d1df0ef6.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for effortless laundry days. This apartment features modern appliances for your comfort and ease.",
      "link": "",
      "alt_text": "Washer and dryer appliances in a laundry closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b59e6faf-cb3a-4430-bd86-5b4f74a95889",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-c164-731b-af98-9165ad018285.webp",
      "image_media": {
        "alt_text": "A fitness center with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "01a03e5b-c164-731b-af98-9165ad018285",
        "storage_key": "property/6767906449167740/01a03e5b-c164-731b-af98-9165ad018285.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines, weight training equipment, and a wide selection of free weights.",
      "link": "",
      "alt_text": "A fitness center with treadmills, ellipticals, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a2af629a-b4d0-4080-82a3-f96354dd54b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-c161-759c-9ba3-93b2bc3e4c88.webp",
      "image_media": {
        "alt_text": "King-size bed with a canopy frame in a bedroom with a patterned rug and floral curtains.",
        "public_id": "01a03e5b-c161-759c-9ba3-93b2bc3e4c88",
        "storage_key": "property/6767906449167740/01a03e5b-c161-759c-9ba3-93b2bc3e4c88.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Decorated bedroom with a king-size bed, canopy frame, and modern furnishings. The room features a patterned rug, floral curtains, and a dresser.",
      "link": "",
      "alt_text": "King-size bed with a canopy frame in a bedroom with a patterned rug and floral curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0a836291-8d64-4144-b2d1-94fc14605e41",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-b685-770a-ab13-f9ec9e093969.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, TV, and dining area with a unique wood-based table.",
        "public_id": "01a03e5b-b685-770a-ab13-f9ec9e093969",
        "storage_key": "property/6767906449167740/01a03e5b-b685-770a-ab13-f9ec9e093969.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Relax and unwind in this stylish living area, featuring comfortable seating, a modern entertainment setup, and a distinct dining space perfect for meals.",
      "link": "",
      "alt_text": "Living room with a sofa, armchair, coffee table, TV, and dining area with a unique wood-based table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_43976015-cf28-4119-9bf5-5d35ff2c3b9e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-b271-77e1-b670-781bd1218f7a.webp",
      "image_media": {
        "alt_text": "Outdoor fitness equipment and playground area with apartment buildings in the background.",
        "public_id": "01a03e5b-b271-77e1-b670-781bd1218f7a",
        "storage_key": "property/6767906449167740/01a03e5b-b271-77e1-b670-781bd1218f7a.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a healthy lifestyle with our state-of-the-art outdoor fitness park and playground, complemented by our beautiful apartment community.",
      "link": "",
      "alt_text": "Outdoor fitness equipment and playground area with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f34bbc8b-8371-42ca-b6a4-a1b4e94650a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-abb3-7779-9158-eacc49dc2518.webp",
      "image_media": {
        "alt_text": "Resort-style pool with lounge chairs and cabanas, surrounded by apartment buildings.",
        "public_id": "01a03e5b-abb3-7779-9158-eacc49dc2518",
        "storage_key": "property/6767906449167740/01a03e5b-abb3-7779-9158-eacc49dc2518.webp",
        "width": 2000,
        "height": 1332
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with comfortable lounge chairs and shaded cabanas. A perfect oasis for relaxation and fun.",
      "link": "",
      "alt_text": "Resort-style pool with lounge chairs and cabanas, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_341c8d55-8708-4cb4-a059-36ae03be4765",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-a251-72ec-9276-86820e686041.webp",
      "image_media": {
        "alt_text": "Resort-style pool and fire pit area with lounge chairs and palm trees.",
        "public_id": "01a03e5b-a251-72ec-9276-86820e686041",
        "storage_key": "property/6767906449167740/01a03e5b-a251-72ec-9276-86820e686041.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy the resort-style pool and gather around the fire pit with friends and family in this beautiful community space.",
      "link": "",
      "alt_text": "Resort-style pool and fire pit area with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_433a08e7-185c-40fe-95d2-49e3328b0380",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-9c0b-73a8-9b0f-7af1985a5180.webp",
      "image_media": {
        "alt_text": "Modern kitchen with a granite island, stainless steel appliances, and light gray cabinets.",
        "public_id": "01a03e5b-9c0b-73a8-9b0f-7af1985a5180",
        "storage_key": "property/6767906449167740/01a03e5b-9c0b-73a8-9b0f-7af1985a5180.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Explore the fully equipped kitchen featuring a spacious granite island, stainless steel appliances, and elegant light gray cabinetry. Perfect for everyday living and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with a granite island, stainless steel appliances, and light gray cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3b6ce229-1b53-477d-8518-3c5444b68078",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-8eee-769f-a648-53cfd4485831.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas at a multifamily property.",
        "public_id": "01a03e5b-8eee-769f-a648-53cfd4485831",
        "storage_key": "property/6767906449167740/01a03e5b-8eee-769f-a648-53cfd4485831.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool, surrounded by comfortable lounge chairs and shaded cabanas for ultimate relaxation.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and cabanas at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6c9f042b-b12d-4b30-838c-96a31580fac2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-8450-744a-a129-2451fb0ed2f0.webp",
      "image_media": {
        "alt_text": "Treadmills, weight machines, dumbbells, and medicine balls in a modern apartment gym.",
        "public_id": "01a03e5b-8450-744a-a129-2451fb0ed2f0",
        "storage_key": "property/6767906449167740/01a03e5b-8450-744a-a129-2451fb0ed2f0.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Community",
      "description": "Stay active and energized in our fully-equipped fitness center, featuring treadmills, weight machines, and free weights for a complete workout.",
      "link": "",
      "alt_text": "Treadmills, weight machines, dumbbells, and medicine balls in a modern apartment gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_564d52eb-1672-4f95-8a2d-6e4622d54bdf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-7e3a-7623-a75c-88d54e8a1fb6.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with island, granite countertops, stainless steel appliances, and bar stools.",
        "public_id": "01a03e5b-7e3a-7623-a75c-88d54e8a1fb6",
        "storage_key": "property/6767906449167740/01a03e5b-7e3a-7623-a75c-88d54e8a1fb6.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish dining area and modern kitchen featuring an island with granite countertops, stainless steel appliances, and comfortable bar stools.",
      "link": "",
      "alt_text": "Dining area and kitchen with island, granite countertops, stainless steel appliances, and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e368a682-39b0-4c93-8567-11d590c91816",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-7561-73b8-9c94-4df3ae19192e.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a03e5b-7561-73b8-9c94-4df3ae19192e",
        "storage_key": "property/6767906449167740/01a03e5b-7561-73b8-9c94-4df3ae19192e.webp",
        "width": 2048,
        "height": 341
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool area, perfect for relaxing and soaking up the sun. Featuring comfortable lounge chairs and shaded umbrellas.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_52c010e64fd494d138daead2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "King's Pizza by: Italian Bistro",
      "poi_type": "Restaurants",
      "poi_address": "3786 Ladson Rd Ste 201, Ladson, SC 29456, USA",
      "poi_short_description": "Understated pizzeria with basic decor turning out New York–style pies & familiar Italian classics.",
      "poi_long_description": "Understated pizzeria with basic decor turning out New York–style pies & familiar Italian classics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5a-fc31-7141-b4ad-adfbc6953b0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5a-fc31-7141-b4ad-adfbc6953b0e",
        "storage_key": "property/6767906449167740/01a03e5a-fc31-7141-b4ad-adfbc6953b0e.webp",
        "width": 289,
        "height": 312
      },
      "poi_business_url": "https://www.kingspizzaladson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11652810288104466996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kings-pizza-by-italian-bistro",
      "poi_latitude": "32.9779624",
      "poi_longitude": "-80.13270399999999",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 843-875-9630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c7cb-748c-a942-6a9919c0578a",
        "storage_key": "property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYHjwDeK_ogRNOp7wTcZt6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_3692ca6338a7477bb82869aa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Gilligan's Seafood Restaurant-Summerville",
      "poi_type": "Restaurants",
      "poi_address": "3852 Ladson Rd, Ladson, SC 29456, USA",
      "poi_short_description": "Oysters & other seafood classics are the specialty of this beachy, low-key cafe & bar.",
      "poi_long_description": "Oysters & other seafood classics are the specialty of this beachy, low-key cafe & bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5a-fcb2-7489-8eee-a0c8e8641a2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5a-fcb2-7489-8eee-a0c8e8641a2e",
        "storage_key": "property/6767906449167740/01a03e5a-fcb2-7489-8eee-a0c8e8641a2e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gilligans.net/locations/summerville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15597882588299261150&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gilligans-seafood-restaurant-summerville",
      "poi_latitude": "32.9750937",
      "poi_longitude": "-80.1373752",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 843-821-2244",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c7cb-748c-a942-6a9919c0578a",
        "storage_key": "property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ61QdxzaK_ogR3vTTq5LPdtg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_ceafa5e29dc0a3c588ab9195",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Culver’s",
      "poi_type": "Restaurants",
      "poi_address": "3848 Ladson Rd, Ladson, SC 29456, USA",
      "poi_short_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_long_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-0193-729f-9f23-c84c9b9c3a61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-0193-729f-9f23-c84c9b9c3a61",
        "storage_key": "property/6767906449167740/01a03e5b-0193-729f-9f23-c84c9b9c3a61.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.culvers.com/restaurants/ladson-sc-ladson/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=13939597042659378828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "culvers",
      "poi_latitude": "32.9755698",
      "poi_longitude": "-80.1365988",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 843-285-9258",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c7cb-748c-a942-6a9919c0578a",
        "storage_key": "property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ89vVH_-L_ogRjEbMt6dlc8E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_f88e0e9db6e3f4066898a7bf",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Krispy Kreme",
      "poi_type": "Restaurants",
      "poi_address": "3651 Ladson Rd, Ladson, SC 29456, USA",
      "poi_short_description": "Longtime chain serving a variety of donut flavors & shapes, plus coffee & frozen drinks.",
      "poi_long_description": "Longtime chain serving a variety of donut flavors & shapes, plus coffee & frozen drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-0061-7083-94e6-e36ebcbc2e38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-0061-7083-94e6-e36ebcbc2e38",
        "storage_key": "property/6767906449167740/01a03e5b-0061-7083-94e6-e36ebcbc2e38.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://site.krispykreme.com/sc/ladson/3651-ladson-rd?y_source=1_MTU0NDcyODAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11574820848940848066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "krispy-kreme",
      "poi_latitude": "32.9821184",
      "poi_longitude": "-80.1242694",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 843-871-0401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c7cb-748c-a942-6a9919c0578a",
        "storage_key": "property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJURl7ryqL_ogRwpPnbzwGoqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "donut_shop"
    },
    {
      "id": "ec_b5e37ced67464da4f396b348",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Dutch Bros Coffee",
      "poi_type": "Restaurants",
      "poi_address": "3678 Ladson Rd, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5a-fd0b-771b-826c-6b257fbe53f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5a-fd0b-771b-826c-6b257fbe53f2",
        "storage_key": "property/6767906449167740/01a03e5a-fd0b-771b-826c-6b257fbe53f2.webp",
        "width": 959,
        "height": 1280
      },
      "poi_business_url": "https://www.dutchbros.com/locations/sc/ladson/3678-ladson-rd?y_source=1_MjA1NTM0MDAwMS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12137867514940486254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dutch-bros-coffee",
      "poi_latitude": "32.9810183",
      "poi_longitude": "-80.1284795",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 877-899-2767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-3f59-755e-a7b1-e55ea996e85c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5b-3f59-755e-a7b1-e55ea996e85c",
        "storage_key": "property/6767906449167740/01a03e5b-3f59-755e-a7b1-e55ea996e85c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJZd0sByKL_ogRbvLHFjJecqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_f377fd129d317db37df5dab3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Nigel's Good Food II",
      "poi_type": "Restaurants",
      "poi_address": "9616 US-78 #11, Ladson, SC 29456, USA",
      "poi_short_description": "Strip-mall dining room featuring fried fish & chicken, turkey wings & other soul-food classics.",
      "poi_long_description": "Strip-mall dining room featuring fried fish & chicken, turkey wings & other soul-food classics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5a-fda8-713d-b5fa-1612685c47a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5a-fda8-713d-b5fa-1612685c47a9",
        "storage_key": "property/6767906449167740/01a03e5a-fda8-713d-b5fa-1612685c47a9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://nigelsgoodfood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4260322961490091918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nigels-good-food-ii",
      "poi_latitude": "32.9896877",
      "poi_longitude": "-80.0983401",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 843-718-1759",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c7cb-748c-a942-6a9919c0578a",
        "storage_key": "property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfx9nE3iK_ogRjp8OTCm1Hzs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "soul_food_restaurant"
    },
    {
      "id": "ec_8d4f70058eb4744d9c5b2147",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Slaughterhouse BBQ & BREW",
      "poi_type": "Restaurants",
      "poi_address": "9616 Hwy 78 Suite 13, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-005d-73cd-91c7-2de64d6661dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-005d-73cd-91c7-2de64d6661dc",
        "storage_key": "property/6767906449167740/01a03e5b-005d-73cd-91c7-2de64d6661dc.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://slaughterhousebbqandbrew.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=820965705562166383&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "slaughterhouse-bbq--brew",
      "poi_latitude": "32.9896262",
      "poi_longitude": "-80.0982526",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 843-789-3090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c7cb-748c-a942-6a9919c0578a",
        "storage_key": "property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPb4SMHNh_ogRb5TPpPWnZAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_483f1095a0be9d5f0a4adda0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Jonny’s Red Tacos",
      "poi_type": "Restaurants",
      "poi_address": "9616 US-78, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5a-fd94-7247-bafd-0fe78eda25ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5a-fd94-7247-bafd-0fe78eda25ee",
        "storage_key": "property/6767906449167740/01a03e5a-fd94-7247-bafd-0fe78eda25ee.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "https://jonnysredtacos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11262975911231933164&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jonnys-red-tacos",
      "poi_latitude": "32.9895593",
      "poi_longitude": "-80.0980206",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 843-433-6337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c7cb-748c-a942-6a9919c0578a",
        "storage_key": "property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtcBUAwBh_ogR7MrC3uogTpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_f8d90958c6d194966b361a10",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Takara Japanese Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "9585 Hwy 78 Ste F, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5a-fff2-72df-8794-d7a5796c0b0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5a-fff2-72df-8794-d7a5796c0b0d",
        "storage_key": "property/6767906449167740/01a03e5a-fff2-72df-8794-d7a5796c0b0d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16570152088735865842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "takara-japanese-steakhouse",
      "poi_latitude": "32.9875408",
      "poi_longitude": "-80.0987686",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 843-974-5343",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c7cb-748c-a942-6a9919c0578a",
        "storage_key": "property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1W7O5XeK_ogR8ltMQ4gB9eU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_f24796c520648129e47ddb43",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Hustleduck Coffee",
      "poi_type": "Restaurants",
      "poi_address": "9614 Hwy 78, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-012d-7260-8822-b2b7dd04b591.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-012d-7260-8822-b2b7dd04b591",
        "storage_key": "property/6767906449167740/01a03e5b-012d-7260-8822-b2b7dd04b591.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hustleduck.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11600760068865314716&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hustleduck-coffee",
      "poi_latitude": "32.9892384",
      "poi_longitude": "-80.09900789999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 800-899-1765",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-3f59-755e-a7b1-e55ea996e85c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5b-3f59-755e-a7b1-e55ea996e85c",
        "storage_key": "property/6767906449167740/01a03e5b-3f59-755e-a7b1-e55ea996e85c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJoYm7kaeL_ogRnM9AtdEt_qA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_96663a65a7de9dd6fcc251b1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Scooter's Coffee",
      "poi_type": "Restaurants",
      "poi_address": "9585 Palmetto Commerce Pkwy, Ladson, SC 29456, USA",
      "poi_short_description": "Drive-thru chain serving espresso & other coffee drinks, plus a variety of smoothies & pastries.",
      "poi_long_description": "Drive-thru chain serving espresso & other coffee drinks, plus a variety of smoothies & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-03fa-7669-86f2-48d7161571fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-03fa-7669-86f2-48d7161571fd",
        "storage_key": "property/6767906449167740/01a03e5b-03fa-7669-86f2-48d7161571fd.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://scooterscoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3411558319116848576&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scooters-coffee",
      "poi_latitude": "32.9799543",
      "poi_longitude": "-80.1255242",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 843-285-5451",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-3f59-755e-a7b1-e55ea996e85c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5b-3f59-755e-a7b1-e55ea996e85c",
        "storage_key": "property/6767906449167740/01a03e5b-3f59-755e-a7b1-e55ea996e85c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJA3anBwCL_ogRwA19TTdKWC8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_aa4bc1ca54921919b9ed46d9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Toast! All Day Summerville",
      "poi_type": "Restaurants",
      "poi_address": "717 Old Trolley Rd Ste 9-10, Summerville, SC 29485, USA",
      "poi_short_description": "Bustling eatery for Lowcountry fare such as biscuits and grits, alongside coffee, bloody marys and mimosas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-0550-72ac-8b52-f9c6ecc9ad5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-0550-72ac-8b52-f9c6ecc9ad5d",
        "storage_key": "property/6767906449167740/01a03e5b-0550-72ac-8b52-f9c6ecc9ad5d.webp",
        "width": 289,
        "height": 312
      },
      "poi_business_url": "https://toastallday.com/locations/toast-summerville",
      "poi_directions_map_url": "https://maps.google.com/?cid=15328395805869534449&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toast-all-day-summerville",
      "poi_latitude": "32.9745523",
      "poi_longitude": "-80.17087509999999",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 843-376-1523",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c7cb-748c-a942-6a9919c0578a",
        "storage_key": "property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzfz2Ku-L_ogR8exwqcVmudQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_38e46e91f63acdb08bd96993",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Magnolia coffee",
      "poi_type": "Restaurants",
      "poi_address": "700 College Park Rd Unit F7, Goose Creek, SC 29445, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-068d-7349-b087-bc0a99d40a30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-068d-7349-b087-bc0a99d40a30",
        "storage_key": "property/6767906449167740/01a03e5b-068d-7349-b087-bc0a99d40a30.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://magnoliacoffeegc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8426421477600498159&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "magnolia-coffee",
      "poi_latitude": "33.0178947",
      "poi_longitude": "-80.08774559999999",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 854-444-2615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c7cb-748c-a942-6a9919c0578a",
        "storage_key": "property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN4pF8_Bh_ogR75EZVLCp8HQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "ec_1ff574ea963d6ccc0730d5cb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Formosa Chinese Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "650 College Park Rd Unit D, Ladson, SC 29456, USA",
      "poi_short_description": "Familiar Chinese offerings & homestyle Filipino dishes in a petite, modest dining room.",
      "poi_long_description": "Familiar Chinese offerings & homestyle Filipino dishes in a petite, modest dining room.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-05e8-74ee-93af-2549821c7d22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-05e8-74ee-93af-2549821c7d22",
        "storage_key": "property/6767906449167740/01a03e5b-05e8-74ee-93af-2549821c7d22.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.facebook.com/pages/Formosa/191254297619400",
      "poi_directions_map_url": "https://maps.google.com/?cid=7063399862320920269&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "formosa-chinese-restaurant",
      "poi_latitude": "33.014067",
      "poi_longitude": "-80.08764029999999",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 843-569-3399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c7cb-748c-a942-6a9919c0578a",
        "storage_key": "property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8YoqlSJg_ogRzXYuVMA8BmI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "ec_10e017a767e3cf2a2e876b53",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "3685 Ladson Rd, Ladson, SC 29456, USA",
      "poi_short_description": "Pharmacy, bakery and grocery chain stocking everyday items electronics, toys, clothing and home goods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-05a1-725f-8f39-ea763822caec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-05a1-725f-8f39-ea763822caec",
        "storage_key": "property/6767906449167740/01a03e5b-05a1-725f-8f39-ea763822caec.webp",
        "width": 1280,
        "height": 1237
      },
      "poi_business_url": "https://www.walmart.com/store/3713-ladson-sc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=18099461261862547094&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "32.9790044",
      "poi_longitude": "-80.12837999999999",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 843-879-5289",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c7d5-711e-8dad-4e61f4c56f91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c7d5-711e-8dad-4e61f4c56f91",
        "storage_key": "property/6767906449167740/01a03e59-c7d5-711e-8dad-4e61f4c56f91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS3fALdeL_ogRlq5CYx80Lvs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_8a7a49e1403fb80f48706793",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "3786 Ladson Rd, Ladson, SC 29456, USA",
      "poi_short_description": "Chain grocery store offering produce, bulk food, and prepared items, plus organic products.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-084b-74b7-853c-a6f8716c4acf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-084b-74b7-853c-a6f8716c4acf",
        "storage_key": "property/6767906449167740/01a03e5b-084b-74b7-853c-a6f8716c4acf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.foodlion.com/sc/ladson/3786-ladson-rd.?y_source=1_NTA0Njg1OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9290431954940105084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "32.9785024",
      "poi_longitude": "-80.13385620000001",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 843-821-5908",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c7d5-711e-8dad-4e61f4c56f91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c7d5-711e-8dad-4e61f4c56f91",
        "storage_key": "property/6767906449167740/01a03e59-c7d5-711e-8dad-4e61f4c56f91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDX8OdDiK_ogRfJEk5KM-7oA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_5d6439aa3444a3b84539c7a6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Piggly Wiggly",
      "poi_type": "Shopping & Retail",
      "poi_address": "9616 US-78, Ladson, SC 29456, USA",
      "poi_short_description": "Grocery store chain featuring meat and produce, plus prepared foods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-0875-70da-b0cf-e6c2a8d2a7f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-0875-70da-b0cf-e6c2a8d2a7f9",
        "storage_key": "property/6767906449167740/01a03e5b-0875-70da-b0cf-e6c2a8d2a7f9.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://thepig.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7879144555761649797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piggly-wiggly",
      "poi_latitude": "32.9900016",
      "poi_longitude": "-80.09867500000001",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 843-572-2119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c7d5-711e-8dad-4e61f4c56f91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c7d5-711e-8dad-4e61f4c56f91",
        "storage_key": "property/6767906449167740/01a03e59-c7d5-711e-8dad-4e61f4c56f91.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpS_69SqL_ogRhUggXDpYWG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_f00ad5773c04b494195d6da9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Piggly Wiggly Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "9616 Hwy 78 Ste 6, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-0acc-751e-8378-0d10a8583731.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-0acc-751e-8378-0d10a8583731",
        "storage_key": "property/6767906449167740/01a03e5b-0acc-751e-8378-0d10a8583731.webp",
        "width": 1280,
        "height": 862
      },
      "poi_business_url": "http://www.pigglywigglyrx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9646693170219150093&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piggly-wiggly-pharmacy",
      "poi_latitude": "32.9899709",
      "poi_longitude": "-80.09889179999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 843-800-8788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-3f5b-7265-8f7b-6bae522071b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5b-3f5b-7265-8f7b-6bae522071b2",
        "storage_key": "property/6767906449167740/01a03e5b-3f5b-7265-8f7b-6bae522071b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIy4UtnmK_ogRDWsZ9FPw34U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_41b372546610a2ee53237d56",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "3868 Ladson Rd, Ladson, SC 29456, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-0acb-768b-bf6b-42f5c186b80e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-0acb-768b-bf6b-42f5c186b80e",
        "storage_key": "property/6767906449167740/01a03e5b-0acb-768b-bf6b-42f5c186b80e.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/sc/summerville/11431",
      "poi_directions_map_url": "https://maps.google.com/?cid=2300405902081925438&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "32.9745193",
      "poi_longitude": "-80.13800789999999",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 843-970-0914",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c7d0-7509-8f19-bb5046267630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c7d0-7509-8f19-bb5046267630",
        "storage_key": "property/6767906449167740/01a03e59-c7d0-7509-8f19-bb5046267630.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJd2LqLdeL_ogRPiHO2Pqu7B8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_1497033833ca6aed53260229",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Valvoline Instant Oil Change",
      "poi_type": "Shopping & Retail",
      "poi_address": "3746 Ladson Rd, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-09b8-713c-af57-691b2419d159.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-09b8-713c-af57-691b2419d159",
        "storage_key": "property/6767906449167740/01a03e5b-09b8-713c-af57-691b2419d159.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://store.vioc.com/sc/ladson/3746-ladson-road?utm_source=google&utm_medium=local&utm_campaign=localsearch",
      "poi_directions_map_url": "https://maps.google.com/?cid=15047085301911320387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valvoline-instant-oil-change",
      "poi_latitude": "32.97965",
      "poi_longitude": "-80.1308",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 843-348-3082",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c838-73ff-8832-72c3154726ea",
        "storage_key": "property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUWaXsCeL_ogRQ_ds9Vv80dA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "car_repair"
    },
    {
      "id": "ec_47277f062b9d1267e603363f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "3752 Ladson Rd, Ladson, SC 29456, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-0c9c-72a0-8321-23fed05eaf62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-0c9c-72a0-8321-23fed05eaf62",
        "storage_key": "property/6767906449167740/01a03e5b-0c9c-72a0-8321-23fed05eaf62.webp",
        "width": 1280,
        "height": 956
      },
      "poi_business_url": "https://www.7-eleven.com/locations/sc/ladson/3752-ladson-rd-40473?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=8143897221225571117&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "32.9790705",
      "poi_longitude": "-80.1316957",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 843-821-2488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-3f66-7597-81db-b684feae511f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5b-3f66-7597-81db-b684feae511f",
        "storage_key": "property/6767906449167740/01a03e5b-3f66-7597-81db-b684feae511f.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJj7HnfDuL_ogRLeNw3l_vBHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_41a7ec0209a11508bb01dff6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Xtreme RC and Hobby",
      "poi_type": "Shopping & Retail",
      "poi_address": "9841 US-78, Ladson, SC 29456, USA",
      "poi_short_description": "Hobby shop stocked with RC cars, trucks, planes and drones, as well as parts and accessories.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-0d41-748b-82ed-de6edd18e76c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-0d41-748b-82ed-de6edd18e76c",
        "storage_key": "property/6767906449167740/01a03e5b-0d41-748b-82ed-de6edd18e76c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4990047275911112129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "xtreme-rc-and-hobby",
      "poi_latitude": "32.9961084",
      "poi_longitude": "-80.1112004",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 843-576-4370",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c7d0-7509-8f19-bb5046267630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c7d0-7509-8f19-bb5046267630",
        "storage_key": "property/6767906449167740/01a03e59-c7d0-7509-8f19-bb5046267630.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZffPUttj_ogRwWUWHY81QEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_608bf4d5e366b31262f8bd6c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "190 Marymeade Dr, Summerville, SC 29483, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e58-fc0a-75bf-b16a-8596f21af020.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e58-fc0a-75bf-b16a-8596f21af020",
        "storage_key": "property/6767906449167740/01a03e58-fc0a-75bf-b16a-8596f21af020.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Summerville/SC/Summerville/29483/1120?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=15589993100379202063&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "33.0307971",
      "poi_longitude": "-80.1614589",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 843-851-0468",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c7d0-7509-8f19-bb5046267630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c7d0-7509-8f19-bb5046267630",
        "storage_key": "property/6767906449167740/01a03e59-c7d0-7509-8f19-bb5046267630.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ05fTxj6L_ogRD6LkHiDIWtg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_0b4bde0d3c308ffff9fb0c17",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "1207 N Main St, Summerville, SC 29483, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e58-ef13-743a-9180-2be6c4073ce6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e58-ef13-743a-9180-2be6c4073ce6",
        "storage_key": "property/6767906449167740/01a03e58-ef13-743a-9180-2be6c4073ce6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.lowes.com/store/SC-Summerville/0358?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-358-_-na-_-0-_-0&y_source=1_MTE4NDE5OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16571297754309922863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "33.032993",
      "poi_longitude": "-80.158068",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 843-851-0066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c7d0-7509-8f19-bb5046267630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c7d0-7509-8f19-bb5046267630",
        "storage_key": "property/6767906449167740/01a03e59-c7d0-7509-8f19-bb5046267630.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBQ0pjTuL_ogRLxDfUIIT-eU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_d957a976a036a17ab87e3f61",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Little People Big World",
      "poi_type": "Education",
      "poi_address": "267 Treeland Dr, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-0e6c-70f5-9ef9-04c6cea07c55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-0e6c-70f5-9ef9-04c6cea07c55",
        "storage_key": "property/6767906449167740/01a03e5b-0e6c-70f5-9ef9-04c6cea07c55.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lpbwacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1860246512184787867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-people-big-world",
      "poi_latitude": "33.0152306",
      "poi_longitude": "-80.1172676",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 843-557-8171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c892-7228-9c14-11e44659d2e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c892-7228-9c14-11e44659d2e0",
        "storage_key": "property/6767906449167740/01a03e59-c892-7228-9c14-11e44659d2e0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHccnOpKK_ogRmwNvyVjs0Bk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_f580d4641c0224e34aeca747",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Little Hands",
      "poi_type": "Education",
      "poi_address": "573 College Park Rd, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-0e6e-7278-b58e-ad0196ff95a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-0e6e-7278-b58e-ad0196ff95a8",
        "storage_key": "property/6767906449167740/01a03e5b-0e6e-7278-b58e-ad0196ff95a8.webp",
        "width": 1280,
        "height": 1079
      },
      "poi_business_url": "http://lhchildcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14280062046225055700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-hands",
      "poi_latitude": "33.0098922",
      "poi_longitude": "-80.0891757",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 843-996-4545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c892-7228-9c14-11e44659d2e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c892-7228-9c14-11e44659d2e0",
        "storage_key": "property/6767906449167740/01a03e59-c892-7228-9c14-11e44659d2e0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ___rhy9g_ogR1D_Io8X4LMY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_fa07b3ddfa13d781cc7e5a7a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Palmetto Child Care",
      "poi_type": "Education",
      "poi_address": "3525 Iron Horse Rd #108, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-0d62-70cf-8b2d-7b649be09c5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-0d62-70cf-8b2d-7b649be09c5c",
        "storage_key": "property/6767906449167740/01a03e5b-0d62-70cf-8b2d-7b649be09c5c.webp",
        "width": 448,
        "height": 358
      },
      "poi_business_url": "http://www.palmettochildcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16943768814936826962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palmetto-child-care",
      "poi_latitude": "32.9828731",
      "poi_longitude": "-80.1151749",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 843-875-5898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c892-7228-9c14-11e44659d2e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c892-7228-9c14-11e44659d2e0",
        "storage_key": "property/6767906449167740/01a03e59-c892-7228-9c14-11e44659d2e0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt1yA9WuK_ogRUqSmGvdbJOs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_9a706667a7cbc74f04233fdf",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Ladson Elementary School",
      "poi_type": "Education",
      "poi_address": "3321 Ladson Rd, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-0f19-75bb-80dc-935e1da247fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-0f19-75bb-80dc-935e1da247fa",
        "storage_key": "property/6767906449167740/01a03e5b-0f19-75bb-80dc-935e1da247fa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ccsdschools.com/ladson",
      "poi_directions_map_url": "https://maps.google.com/?cid=12457091139819451955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ladson-elementary-school",
      "poi_latitude": "32.9854233",
      "poi_longitude": "-80.10595380000001",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 843-818-1858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c892-7228-9c14-11e44659d2e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c892-7228-9c14-11e44659d2e0",
        "storage_key": "property/6767906449167740/01a03e59-c892-7228-9c14-11e44659d2e0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-cwHa3GK_ogRM7aaI2R64Kw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_25813170052382667d16825e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Deer Park Middle School",
      "poi_type": "Education",
      "poi_address": "2263 Otranto Rd, North Charleston, SC 29406, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-1191-753f-9f06-45965de57107.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-1191-753f-9f06-45965de57107",
        "storage_key": "property/6767906449167740/01a03e5b-1191-753f-9f06-45965de57107.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ccsdschools.com/deerpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=10707912464226044829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deer-park-middle-school",
      "poi_latitude": "32.9635626",
      "poi_longitude": "-80.0490021",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 843-990-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c892-7228-9c14-11e44659d2e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c892-7228-9c14-11e44659d2e0",
        "storage_key": "property/6767906449167740/01a03e59-c892-7228-9c14-11e44659d2e0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhYvrR3dh_ogRncsrPKclmpQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_3ea65d1ad96631bcf91df288",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "R.B. Stall High School",
      "poi_type": "Education",
      "poi_address": "3625 Ashley Phosphate Rd, North Charleston, SC 29418, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-100a-7646-b3a6-7d68eda6308a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-100a-7646-b3a6-7d68eda6308a",
        "storage_key": "property/6767906449167740/01a03e5b-100a-7646-b3a6-7d68eda6308a.webp",
        "width": 1280,
        "height": 186
      },
      "poi_business_url": "https://www.ccsdschools.com/stall",
      "poi_directions_map_url": "https://maps.google.com/?cid=17338180560998263456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rb-stall-high-school",
      "poi_latitude": "32.9227581",
      "poi_longitude": "-80.0799828",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 843-764-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c892-7228-9c14-11e44659d2e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c892-7228-9c14-11e44659d2e0",
        "storage_key": "property/6767906449167740/01a03e59-c892-7228-9c14-11e44659d2e0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaR8mqS1i_ogRoGrizVuXnfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_6063c364e2d9cd66b1556217",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Faith Christian School and Preschool",
      "poi_type": "Education",
      "poi_address": "337 Farmington Rd, Summerville, SC 29486, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.faithchristiansc.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1933470765063947027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "faith-christian-school-and-preschool",
      "poi_latitude": "33.0220233",
      "poi_longitude": "-80.1277188",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 843-873-8464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c892-7228-9c14-11e44659d2e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c892-7228-9c14-11e44659d2e0",
        "storage_key": "property/6767906449167740/01a03e59-c892-7228-9c14-11e44659d2e0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJm--yReiK_ogRE0M9t2oR1Ro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_fcfea46e93e6a16121b0ec17",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Ridge Christian Academy",
      "poi_type": "Education",
      "poi_address": "2168 Ridge Church Rd, Summerville, SC 29483, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://ridgechristian.info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13197290216399070077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ridge-christian-academy",
      "poi_latitude": "33.0414487",
      "poi_longitude": "-80.11115269999999",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 843-873-9856",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c892-7228-9c14-11e44659d2e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c892-7228-9c14-11e44659d2e0",
        "storage_key": "property/6767906449167740/01a03e59-c892-7228-9c14-11e44659d2e0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx_l-P7KK_ogRfWM0kocxJrc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_13f0a577ece9a7972ebd0c5c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Charleston Southern University",
      "poi_type": "Education",
      "poi_address": "9200 University Blvd, North Charleston, SC 29406, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e58-eb37-74ef-8231-1e7244613b9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e58-eb37-74ef-8231-1e7244613b9c",
        "storage_key": "property/6767906449167740/01a03e58-eb37-74ef-8231-1e7244613b9c.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.charlestonsouthern.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18389572263007151393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charleston-southern-university",
      "poi_latitude": "32.9821829",
      "poi_longitude": "-80.07065539999999",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-863-7050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c892-7228-9c14-11e44659d2e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c892-7228-9c14-11e44659d2e0",
        "storage_key": "property/6767906449167740/01a03e59-c892-7228-9c14-11e44659d2e0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCTNMZLlh_ogRIeXqg4riNP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_1a390727a52ddf8b7a46ffd3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Trident Technical College Dorchester Campus",
      "poi_type": "Education",
      "poi_address": "10055 Dorchester Rd, Summerville, SC 29485, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-14ad-762b-9099-dd52e40a9e35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-14ad-762b-9099-dd52e40a9e35",
        "storage_key": "property/6767906449167740/01a03e5b-14ad-762b-9099-dd52e40a9e35.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.tridenttech.edu/about/locations/dorchester/index.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=12832939076197151377&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trident-technical-college-dorchester-campus",
      "poi_latitude": "32.9512901",
      "poi_longitude": "-80.16492459999999",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 843-574-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c892-7228-9c14-11e44659d2e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c892-7228-9c14-11e44659d2e0",
        "storage_key": "property/6767906449167740/01a03e59-c892-7228-9c14-11e44659d2e0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGz-nXHSJ_ogRkfL1FBnCF7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_9cacbe07cfb1ae6c2d0189a4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Cinemark Summerville",
      "poi_type": "Entertainment",
      "poi_address": "4488 Ladson Rd, Summerville, SC 29485, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-14ae-733f-8b02-01d5a0ed861a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-14ae-733f-8b02-01d5a0ed861a",
        "storage_key": "property/6767906449167740/01a03e5b-14ae-733f-8b02-01d5a0ed861a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cinemark.com/theatres/sc-summerville/cinemark-summerville?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&y_source=1_MTc0OTI5MjMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10669461560650978369&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-summerville",
      "poi_latitude": "32.9586398",
      "poi_longitude": "-80.16016859999999",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 843-873-1501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-3f59-755e-a7b1-eb6aa481759c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5b-3f59-755e-a7b1-eb6aa481759c",
        "storage_key": "property/6767906449167740/01a03e5b-3f59-755e-a7b1-eb6aa481759c.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6QEgZ9eL_ogRQVRJm8KKEZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_ca98fae5c6d7b40e1aa4f77e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Regal Azalea Square",
      "poi_type": "Entertainment",
      "poi_address": "215 Azalea Square Blvd, Summerville, SC 29483, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-12f5-7599-9a9f-16fe4e80813b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-12f5-7599-9a9f-16fe4e80813b",
        "storage_key": "property/6767906449167740/01a03e5b-12f5-7599-9a9f-16fe4e80813b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-azalea-square-rpx-1850?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=10916881957278998755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-azalea-square",
      "poi_latitude": "33.03669259999999",
      "poi_longitude": "-80.16056669999999",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-3f59-755e-a7b1-eb6aa481759c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5b-3f59-755e-a7b1-eb6aa481759c",
        "storage_key": "property/6767906449167740/01a03e5b-3f59-755e-a7b1-eb6aa481759c.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJyx287TmL_ogR42B8zkyOgJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_350496121f67c3891924abdd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Stars and Strikes",
      "poi_type": "Entertainment",
      "poi_address": "4570 Ladson Rd, Summerville, SC 29485, USA",
      "poi_short_description": "Family entertainment center with bowling, arcade games, laser tag, and bumper cars, plus an American restaurant.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-176f-76da-82fd-bb01b9f0a7eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-176f-76da-82fd-bb01b9f0a7eb",
        "storage_key": "property/6767906449167740/01a03e5b-176f-76da-82fd-bb01b9f0a7eb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://starsandstrikes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=414138114840669674&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stars-and-strikes",
      "poi_latitude": "32.9565168",
      "poi_longitude": "-80.1612976",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 678-965-5707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c838-73ff-8832-72c3154726ea",
        "storage_key": "property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV7LUTdaJ_ogR6i0H12tQvwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "ec_e406ab232dbd57385ec05671",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "North Charleston Coliseum & Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "5001 Coliseum Dr, North Charleston, SC 29418, USA",
      "poi_short_description": "Indoor stadium & adjacent theater where thousands watch minor league hockey, concerts & plays.",
      "poi_long_description": "Indoor stadium & adjacent theater where thousands watch minor league hockey, concerts & plays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-1827-75ad-935d-9d3c2cafdd8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-1827-75ad-935d-9d3c2cafdd8d",
        "storage_key": "property/6767906449167740/01a03e5b-1827-75ad-935d-9d3c2cafdd8d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.northcharlestoncoliseumpac.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4984177135569200452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-charleston-coliseum--performing-arts-center",
      "poi_latitude": "32.8654952",
      "poi_longitude": "-80.02243399999999",
      "poi_miles_from_property": "15.2 mi",
      "poi_walking_minutes": "5 hours 34 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 843-529-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c838-73ff-8832-72c3154726ea",
        "storage_key": "property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi6YMfE5j_ogRROU5j7JaK0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "ec_a3bb3ead41c794e99ce01ff9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Topgolf Charleston",
      "poi_type": "Restaurants",
      "poi_address": "5000 Topgolf Wy, North Charleston, SC 29418, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-169f-757c-8b66-46ff23fb92a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-169f-757c-8b66-46ff23fb92a7",
        "storage_key": "property/6767906449167740/01a03e5b-169f-757c-8b66-46ff23fb92a7.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://topgolf.com/us/charleston/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4925040528399343657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-charleston",
      "poi_latitude": "32.869225",
      "poi_longitude": "-80.016504",
      "poi_miles_from_property": "15.8 mi",
      "poi_walking_minutes": "5 hours 47 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 854-895-4034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c7cb-748c-a942-6a9919c0578a",
        "storage_key": "property/6767906449167740/01a03e59-c7cb-748c-a942-6a9919c0578a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgzTeIedj_ogRKSClP0RCWUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_df5048e27951914572b47773",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Riverfront Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1061 Everglades Ave, North Charleston, SC 29405, USA",
      "poi_short_description": "This popular green space along the Cooper River features a large meadow & performance pavilion.",
      "poi_long_description": "This popular green space along the Cooper River features a large meadow & performance pavilion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-1764-778b-a4c1-b23d2a9e4602.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-1764-778b-a4c1-b23d2a9e4602",
        "storage_key": "property/6767906449167740/01a03e5b-1764-778b-a4c1-b23d2a9e4602.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.northcharleston.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8626706816767301319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverfront-park",
      "poi_latitude": "32.8675754",
      "poi_longitude": "-79.966717",
      "poi_miles_from_property": "14.8 mi",
      "poi_walking_minutes": "5 hours 27 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 843-308-4746",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c88c-7348-aa9c-e414c9f6caeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c88c-7348-aa9c-e414c9f6caeb",
        "storage_key": "property/6767906449167740/01a03e59-c88c-7348-aa9c-e414c9f6caeb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZZpkTthk_ogRxxbbwiQ4uHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_99d31f226e0f2285682c320b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "South Carolina Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "100 Aquarium Wharf, Charleston, SC 29401, USA",
      "poi_short_description": "Massive aquarium with interactive exhibits & hundreds of creatures, including many native species.",
      "poi_long_description": "Massive aquarium with interactive exhibits & hundreds of creatures, including many native species.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-1b3a-724f-8954-26878e8d5868.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-1b3a-724f-8954-26878e8d5868",
        "storage_key": "property/6767906449167740/01a03e5b-1b3a-724f-8954-26878e8d5868.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://scaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2084058560928962106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-carolina-aquarium",
      "poi_latitude": "32.7909936",
      "poi_longitude": "-79.92549919999999",
      "poi_miles_from_property": "34.9 mi",
      "poi_walking_minutes": "12 hours 40 mins",
      "poi_biking_minutes": "2 hours 3 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 843-577-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-3f6b-73ee-9467-030f00e944af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5b-3f6b-73ee-9467-030f00e944af",
        "storage_key": "property/6767906449167740/01a03e5b-3f6b-73ee-9467-030f00e944af.webp",
        "width": 192,
        "height": 176
      },
      "poi_google_place_id": "ChIJof9jW3F6_ogROlZIJzgQ7Bw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "ec_62ce67ed70f960cb7e8aca87",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Childrens Museum of the Lowcountry",
      "poi_type": "Entertainment",
      "poi_address": "25 Ann St, Charleston, SC 29403, USA",
      "poi_short_description": "Hands-on exhibits for under-10 kids plus parties, programs, camps & classes such as yoga & dance.",
      "poi_long_description": "Hands-on exhibits for under-10 kids plus parties, programs, camps & classes such as yoga & dance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-1b56-716a-98ed-14938555f671.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-1b56-716a-98ed-14938555f671",
        "storage_key": "property/6767906449167740/01a03e5b-1b56-716a-98ed-14938555f671.webp",
        "width": 1275,
        "height": 753
      },
      "poi_business_url": "http://www.explorecml.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3212388673014336480&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-museum-of-the-lowcountry",
      "poi_latitude": "32.789416",
      "poi_longitude": "-79.9376529",
      "poi_miles_from_property": "34.0 mi",
      "poi_walking_minutes": "12 hours 21 mins",
      "poi_biking_minutes": "2 hours 1 min",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-3f9c-70ae-91f9-afd0cde565d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5b-3f9c-70ae-91f9-afd0cde565d6",
        "storage_key": "property/6767906449167740/01a03e5b-3f9c-70ae-91f9-afd0cde565d6.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJT4cWvWt6_ogR4AuCZ3qylCw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_647b77c64fcf6c4bf734298e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Music Farm",
      "poi_type": "Entertainment",
      "poi_address": "32 Ann St, Charleston, SC 29403, USA",
      "poi_short_description": "Bands & a full bar featured in a standing-only concert & event hall housed in a former train shed.",
      "poi_long_description": "Bands & a full bar featured in a standing-only concert & event hall housed in a former train shed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-1b3b-714c-b044-3f545060fff1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-1b3b-714c-b044-3f545060fff1",
        "storage_key": "property/6767906449167740/01a03e5b-1b3b-714c-b044-3f545060fff1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://musicfarm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18432997355552395870&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "music-farm",
      "poi_latitude": "32.78998869999999",
      "poi_longitude": "-79.93815049999999",
      "poi_miles_from_property": "34.1 mi",
      "poi_walking_minutes": "12 hours 22 mins",
      "poi_biking_minutes": "2 hours 0 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 843-853-2252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c838-73ff-8832-72c3154726ea",
        "storage_key": "property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ26Ant2t6_ogRXlJqw24pz_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_ea89e057321632825934adbe",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Patriots Point Naval & Maritime Museum",
      "poi_type": "Entertainment",
      "poi_address": "40 Patriots Point Rd, Mt Pleasant, SC 29464, USA",
      "poi_short_description": "Visitors can explore a retired Naval aircraft carrier, destroyer & submarine docked here year-round.",
      "poi_long_description": "Visitors can explore a retired Naval aircraft carrier, destroyer & submarine docked here year-round.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-2655-7679-b73c-98d973a455e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-2655-7679-b73c-98d973a455e4",
        "storage_key": "property/6767906449167740/01a03e5b-2655-7679-b73c-98d973a455e4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.patriotspoint.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2736798978077254358&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "patriots-point-naval--maritime-museum",
      "poi_latitude": "32.7905312",
      "poi_longitude": "-79.9056076",
      "poi_miles_from_property": "38.1 mi",
      "poi_walking_minutes": "13 hours 50 mins",
      "poi_biking_minutes": "2 hours 16 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 843-884-2727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-3f9c-70ae-91f9-afd0cde565d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5b-3f9c-70ae-91f9-afd0cde565d6",
        "storage_key": "property/6767906449167740/01a03e5b-3f9c-70ae-91f9-afd0cde565d6.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJCZ61VpBw_ogR1mLynSsQ-yU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_052e578fb7c2c5ceab6b9431",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "HCA Healthcare Trident Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "9330 Medical Plaza Dr, North Charleston, SC 29406, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-1ff1-71fd-98ec-8c664cb504fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-1ff1-71fd-98ec-8c664cb504fc",
        "storage_key": "property/6767906449167740/01a03e59-1ff1-71fd-98ec-8c664cb504fc.webp",
        "width": 1010,
        "height": 568
      },
      "poi_business_url": "https://www.tridenthealthsystem.com/locations/trident-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=18177182806905145430&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-healthcare-trident-hospital",
      "poi_latitude": "32.9762771",
      "poi_longitude": "-80.07362309999999",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 843-797-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c84b-777d-9901-190f00971a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c84b-777d-9901-190f00971a77",
        "storage_key": "property/6767906449167740/01a03e59-c84b-777d-9901-190f00971a77.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJyTtamr9h_ogRVkjrvnRTQvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_3a9541339c477b4c424900aa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "HCA Healthcare Summerville Hospital, A part of Trident Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "295 Midland Pkwy, Summerville, SC 29485, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-2751-777b-a843-d288da859330.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-2751-777b-a843-d288da859330",
        "storage_key": "property/6767906449167740/01a03e59-2751-777b-a843-d288da859330.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.tridenthealthsystem.com/locations/summerville-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4709934292123430214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-healthcare-summerville-hospital-a-part-of-trident-hospital",
      "poi_latitude": "32.9657337",
      "poi_longitude": "-80.1575356",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 843-970-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c84b-777d-9901-190f00971a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c84b-777d-9901-190f00971a77",
        "storage_key": "property/6767906449167740/01a03e59-c84b-777d-9901-190f00971a77.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJzy_JxduL_ogRRq1yzUgMXUE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_2bdb9543f6e9a7b5f5cdc216",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Roper St. Francis Express Care",
      "poi_type": "Health and Wellness",
      "poi_address": "4278 Ladson Rd, Summerville, SC 29485, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-2f8e-7148-a871-a87225f5e84c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-2f8e-7148-a871-a87225f5e84c",
        "storage_key": "property/6767906449167740/01a03e5b-2f8e-7148-a871-a87225f5e84c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.rsfh.com/express-care/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10224232497040185996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roper-st-francis-express-care",
      "poi_latitude": "32.963744",
      "poi_longitude": "-80.1538918",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-203-2240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c838-73ff-8832-72c3154726ea",
        "storage_key": "property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzfEUX9eL_ogRjNoVJ0nF440",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_05b545027995248f49c0782d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "HCA CareNow - Summerville",
      "poi_type": "Health and Wellness",
      "poi_address": "1675 N Main St, Summerville, SC 29486, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-1f97-755e-81ae-5edb0f0db318.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-1f97-755e-81ae-5edb0f0db318",
        "storage_key": "property/6767906449167740/01a03e5b-1f97-755e-81ae-5edb0f0db318.webp",
        "width": 940,
        "height": 611
      },
      "poi_business_url": "https://www.carenow.com/locations/charleston/summerville?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=2974656415898178883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-carenow---summerville",
      "poi_latitude": "33.0404662",
      "poi_longitude": "-80.1353855",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 843-285-2169",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c838-73ff-8832-72c3154726ea",
        "storage_key": "property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQzxgbtGK_ogRQ5Vy9j8aSCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_33cd347d610326ce254805c4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "CareNow Urgent Care - North Charleston",
      "poi_type": "Health and Wellness",
      "poi_address": "8445 Dorchester Rd, North Charleston, SC 29420, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-1f4e-704e-802c-a7a4e15a5e80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-1f4e-704e-802c-a7a4e15a5e80",
        "storage_key": "property/6767906449167740/01a03e5b-1f4e-704e-802c-a7a4e15a5e80.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.carenow.com/locations/charleston/north-charleston?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1190181963690788558&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---north-charleston",
      "poi_latitude": "32.9152296",
      "poi_longitude": "-80.1104402",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 843-640-5008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c838-73ff-8832-72c3154726ea",
        "storage_key": "property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-9-Z7M2J_ogRzsbdqzBghBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_12d62fe55db9588c585d5300",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "CrossFit Sacred Pine",
      "poi_type": "Health and Wellness",
      "poi_address": "3507 Iron Horse Rd Unit 300, Ladson, SC 29456, USA",
      "poi_short_description": "Cozy gym offering CrossFit workouts and classes, plus coaches who modify movements as needed.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-2209-74f9-ba7c-3bb6693047a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-2209-74f9-ba7c-3bb6693047a6",
        "storage_key": "property/6767906449167740/01a03e5b-2209-74f9-ba7c-3bb6693047a6.webp",
        "width": 960,
        "height": 541
      },
      "poi_business_url": "https://sacredpinefitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16826905831592729490&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossfit-sacred-pine",
      "poi_latitude": "32.9831107",
      "poi_longitude": "-80.1133413",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 843-919-4869",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c838-73ff-8832-72c3154726ea",
        "storage_key": "property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdZz1MWyK_ogRkpsIebMthek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_415d4f4292ab666f62afa65c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Ladson Oakbrook Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "4500 Ladson Rd, Ladson, SC 29456, USA",
      "poi_short_description": "Shopping mall offering entertainment and dining options including bowling, a movie theater, and a Freddy's Frozen Custard.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-217f-71ca-bd66-f34b90998953.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-217f-71ca-bd66-f34b90998953",
        "storage_key": "property/6767906449167740/01a03e5b-217f-71ca-bd66-f34b90998953.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ziffcre.propertycapsule.com/p/commercial-real-estate-listings/Summerville-SC-29485/ladsonoakbrook",
      "poi_directions_map_url": "https://maps.google.com/?cid=10033630011993609056&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ladson-oakbrook-shopping-center",
      "poi_latitude": "32.9579909",
      "poi_longitude": "-80.1604718",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 843-724-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c7d0-7509-8f19-bb5046267630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c7d0-7509-8f19-bb5046267630",
        "storage_key": "property/6767906449167740/01a03e59-c7d0-7509-8f19-bb5046267630.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJkzyNkWGJ_ogRYNOT4FWdPos",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_8cd3ec5266c25229808c1d8c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Oakbrook Nature Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Springview Ln, Summerville, SC 29485, USA",
      "poi_short_description": "This 0.6-mile loop trail in a preserved forest area is paved with gravel & boardwalk.",
      "poi_long_description": "This 0.6-mile loop trail in a preserved forest area is paved with gravel & boardwalk.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-219c-7282-a122-c98aa0d41fa1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-219c-7282-a122-c98aa0d41fa1",
        "storage_key": "property/6767906449167740/01a03e5b-219c-7282-a122-c98aa0d41fa1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.summervillesc.gov/facilities/facility/details/Oakbrook-Nature-Trail-15",
      "poi_directions_map_url": "https://maps.google.com/?cid=11684877905884767822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oakbrook-nature-trail",
      "poi_latitude": "32.9629672",
      "poi_longitude": "-80.1584396",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 843-851-5211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c88c-7348-aa9c-e414c9f6caeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c88c-7348-aa9c-e414c9f6caeb",
        "storage_key": "property/6767906449167740/01a03e59-c88c-7348-aa9c-e414c9f6caeb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIdNOKNmL_ogRTmYS2IsGKaI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_0c994f5763142f74fecce6ff",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Sawmill Branch Trail - E. Richardson Ave. Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Summerville, SC 29485, USA",
      "poi_short_description": "Paved pathway for walking and biking, plus a stream and views of ducks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-23b7-7520-999e-2724077ba924.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-23b7-7520-999e-2724077ba924",
        "storage_key": "property/6767906449167740/01a03e5b-23b7-7520-999e-2724077ba924.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9671525398587093533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sawmill-branch-trail---e-richardson-ave-trailhead",
      "poi_latitude": "33.0152016",
      "poi_longitude": "-80.1698686",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-3f66-7597-81db-b8fbebdbcc05.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5b-3f66-7597-81db-b8fbebdbcc05",
        "storage_key": "property/6767906449167740/01a03e5b-3f66-7597-81db-b8fbebdbcc05.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJH5bkFnKL_ogRHbLzqhspOIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_27a84d155229c4c68c2846d7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Gahagan Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "184 W Boundary St, Summerville, SC 29485, USA",
      "poi_short_description": "Family-friendly park with baseball & football fields, plus a castle-like playground & picnic tables.",
      "poi_long_description": "Family-friendly park with baseball & football fields, plus a castle-like playground & picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-3184-73d7-9cfc-2d91b4a9b835.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-3184-73d7-9cfc-2d91b4a9b835",
        "storage_key": "property/6767906449167740/01a03e59-3184-73d7-9cfc-2d91b4a9b835.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.summervillesc.gov/519/Parks-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=6232569376996974259&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gahagan-park",
      "poi_latitude": "33.00887",
      "poi_longitude": "-80.1662731",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 843-510-0005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c88c-7348-aa9c-e414c9f6caeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c88c-7348-aa9c-e414c9f6caeb",
        "storage_key": "property/6767906449167740/01a03e59-c88c-7348-aa9c-e414c9f6caeb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJqcFLOQuL_ogRs97hqdOIflY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_b561f6b6101d5d0182bdf205",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Rosebrock Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "507 Beech Hill Rd, Summerville, SC 29485, USA",
      "poi_short_description": "Natural setting for riverside hikes through forest & wetlands, plus a picnic shelter.",
      "poi_long_description": "Natural setting for riverside hikes through forest & wetlands, plus a picnic shelter.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-2390-729f-8ff4-acd93c91ceda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-2390-729f-8ff4-acd93c91ceda",
        "storage_key": "property/6767906449167740/01a03e5b-2390-729f-8ff4-acd93c91ceda.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dorchestercountysc.gov/services/parks-recreation/rosebrock-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16520332637351917944&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rosebrock-park",
      "poi_latitude": "32.9489457",
      "poi_longitude": "-80.2059668",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 843-832-0193",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c88c-7348-aa9c-e414c9f6caeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c88c-7348-aa9c-e414c9f6caeb",
        "storage_key": "property/6767906449167740/01a03e59-c88c-7348-aa9c-e414c9f6caeb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJL5ApnaeO_ogReDmnVAEDROU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_9f3c0f33d2d789112346ef0d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Ashley River Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "200 Renken Rd, Summerville, SC 29485, USA",
      "poi_short_description": "Relaxed riverside park featuring playgrounds, walking trails, dog parks and zip lines.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-52fe-72a2-9062-d310480eb333.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-52fe-72a2-9062-d310480eb333",
        "storage_key": "property/6767906449167740/01a03e59-52fe-72a2-9062-d310480eb333.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.dorchestercountysc.gov/services/parks-recreation/parks-master-plan/ashley-river-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8523128911980528156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ashley-river-park",
      "poi_latitude": "32.9596824",
      "poi_longitude": "-80.2003158",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 843-806-2426",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c88c-7348-aa9c-e414c9f6caeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c88c-7348-aa9c-e414c9f6caeb",
        "storage_key": "property/6767906449167740/01a03e59-c88c-7348-aa9c-e414c9f6caeb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ97nbMiaP_ogRHAJ2hZY8SHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_9796a380932316b4b7e44f96",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Herbert H. Jessen Public Boat Landing",
      "poi_type": "Entertainment",
      "poi_address": "4820 Ladson Rd, Summerville, SC 29485, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-26b6-72a7-8968-3e31c213875c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-26b6-72a7-8968-3e31c213875c",
        "storage_key": "property/6767906449167740/01a03e5b-26b6-72a7-8968-3e31c213875c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.summervillesc.gov/Facilities/Facility/Details/Herbert-H-Jessen-Boat-Landing-10",
      "poi_directions_map_url": "https://maps.google.com/?cid=6858014639842278247&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "herbert-h-jessen-public-boat-landing",
      "poi_latitude": "32.947468",
      "poi_longitude": "-80.164812",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c838-73ff-8832-72c3154726ea",
        "storage_key": "property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu3r7I2iJ_ogRZzs6yPqPLF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_a69ebfcb33ce87f7366a6a11",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Colonial Dorchester State Historic Site",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 State Park Rd, Summerville, SC 29485, USA",
      "poi_short_description": "Colonial-era settlement with many original buildings & ruins, archaeological digs & guided tours.",
      "poi_long_description": "Colonial-era settlement with many original buildings & ruins, archaeological digs & guided tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-2700-715b-a70d-305322199d68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-2700-715b-a70d-305322199d68",
        "storage_key": "property/6767906449167740/01a03e5b-2700-715b-a70d-305322199d68.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.southcarolinaparks.com/colonialdorchester",
      "poi_directions_map_url": "https://maps.google.com/?cid=13989591396413956151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colonial-dorchester-state-historic-site",
      "poi_latitude": "32.9487557",
      "poi_longitude": "-80.1705363",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 843-873-1740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c88c-7348-aa9c-e414c9f6caeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c88c-7348-aa9c-e414c9f6caeb",
        "storage_key": "property/6767906449167740/01a03e59-c88c-7348-aa9c-e414c9f6caeb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiRy4OfGL_ogRN2AdSEEDJcI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "ec_cd2f4e02496a636ad0156cc4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Wescott Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9006 Dorchester Rd, North Charleston, SC 29420, USA",
      "poi_short_description": "Baseball/softball complex with batting cages, play structures, off-leash dog areas & picnic sites.",
      "poi_long_description": "Baseball/softball complex with batting cages, play structures, off-leash dog areas & picnic sites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-297c-7047-bc19-81cb5ae8ffe3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-297c-7047-bc19-81cb5ae8ffe3",
        "storage_key": "property/6767906449167740/01a03e5b-297c-7047-bc19-81cb5ae8ffe3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://recreation.northcharleston.org/parks_facilities/wescott_park.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=17781894826064787549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wescott-park",
      "poi_latitude": "32.9307707",
      "poi_longitude": "-80.1340597",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 843-767-0782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c88c-7348-aa9c-e414c9f6caeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c88c-7348-aa9c-e414c9f6caeb",
        "storage_key": "property/6767906449167740/01a03e59-c88c-7348-aa9c-e414c9f6caeb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjxAUP6OJ_ogRXbjyvCH7xfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_cc0ed63f8ae44fab3744463c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Hutchinson Square",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Summerville, SC 29483, USA",
      "poi_short_description": "Landscaped square in the heart of downtown, the site of frequent community gatherings & festivals.",
      "poi_long_description": "Landscaped square in the heart of downtown, the site of frequent community gatherings & festivals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-29d7-71fa-b1a0-04767de09703.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-29d7-71fa-b1a0-04767de09703",
        "storage_key": "property/6767906449167740/01a03e5b-29d7-71fa-b1a0-04767de09703.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.summervillesc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12674665953607011736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hutchinson-square",
      "poi_latitude": "33.0198706",
      "poi_longitude": "-80.17535",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 843-871-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c88c-7348-aa9c-e414c9f6caeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c88c-7348-aa9c-e414c9f6caeb",
        "storage_key": "property/6767906449167740/01a03e59-c88c-7348-aa9c-e414c9f6caeb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4eq8dm-L_ogRmM17E4h15a8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_313b29f25058278d3e109aa3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Azalea Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "105 W 5th S St, Summerville, SC 29483, USA",
      "poi_short_description": "Scenic park with landscaped flower beds, ponds, sculptures, winding walking trails & tennis courts.",
      "poi_long_description": "Scenic park with landscaped flower beds, ponds, sculptures, winding walking trails & tennis courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-2ce5-7169-af38-40f79ba0c700.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-2ce5-7169-af38-40f79ba0c700",
        "storage_key": "property/6767906449167740/01a03e5b-2ce5-7169-af38-40f79ba0c700.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.summervillesc.gov/196/Parks-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=16921181544976970789&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "azalea-park",
      "poi_latitude": "33.0143515",
      "poi_longitude": "-80.1774669",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 843-851-5211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c88c-7348-aa9c-e414c9f6caeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c88c-7348-aa9c-e414c9f6caeb",
        "storage_key": "property/6767906449167740/01a03e59-c88c-7348-aa9c-e414c9f6caeb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6fBkAnuL_ogRJXQ_gPYc1Oo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_5a395f1c1abd75ea5e3c917e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Charleston International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5500 International Blvd, North Charleston, SC 29418, USA",
      "poi_short_description": "Long-standing regional airport serving the Southeast & featuring various rental car options.",
      "poi_long_description": "Long-standing regional airport serving the Southeast & featuring various rental car options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-2b4b-7764-98f8-103f4e44f6bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-2b4b-7764-98f8-103f4e44f6bf",
        "storage_key": "property/6767906449167740/01a03e5b-2b4b-7764-98f8-103f4e44f6bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.iflychs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2038942955165646559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charleston-international-airport",
      "poi_latitude": "32.8916648",
      "poi_longitude": "-80.0395233",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 11 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 843-767-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-3f5d-70cc-a636-9911b0e6818f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5b-3f5d-70cc-a636-9911b0e6818f",
        "storage_key": "property/6767906449167740/01a03e5b-3f5d-70cc-a636-9911b0e6818f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJoyrqSw9j_ogR3_7un9DHSxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_aa7ecc54cfe4fbec4c1fcd0b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "North Charleston Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Melnick Dr, North Charleston, SC 29406, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-2adb-752d-9ad8-248bdadce26c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-2adb-752d-9ad8-248bdadce26c",
        "storage_key": "property/6767906449167740/01a03e5b-2adb-752d-9ad8-248bdadce26c.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://ridecarta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7348761912706324910&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-charleston-park--ride",
      "poi_latitude": "32.9610865",
      "poi_longitude": "-80.0470412",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 843-724-7420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-3f9b-77bc-a1ca-49395c2b70af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5b-3f9b-77bc-a1ca-49395c2b70af",
        "storage_key": "property/6767906449167740/01a03e5b-3f9b-77bc-a1ca-49395c2b70af.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJJbJnFGRh_ogRrtnHMQYM_GU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_8835bef348fa0391ea91ef21",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "N. Charleston Superstop",
      "poi_type": "Transportation & Transit",
      "poi_address": "intersection of Rivers Avenue and Cosgrove Avenue, Rivers Ave, North Charleston, SC 29405, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.ridecarta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5989826832907687495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "n-charleston-superstop",
      "poi_latitude": "32.8555841",
      "poi_longitude": "-79.976547",
      "poi_miles_from_property": "14.7 mi",
      "poi_walking_minutes": "5 hours 26 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 843-724-7420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-3f96-72db-bed2-33ea1757960f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5b-3f96-72db-bed2-33ea1757960f",
        "storage_key": "property/6767906449167740/01a03e5b-3f96-72db-bed2-33ea1757960f.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJKdTutTJ7_ogRR9aQ4cQjIFM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_72e815a052d29420eda65566",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Festival Centre - North Charleston",
      "poi_type": "Shopping & Retail",
      "poi_address": "5101 Ashley Phosphate Rd, North Charleston, SC 29418, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-2db6-77db-9135-c3a7149b9066.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-2db6-77db-9135-c3a7149b9066",
        "storage_key": "property/6767906449167740/01a03e5b-2db6-77db-9135-c3a7149b9066.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.woodlockcapital.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9020550980514083595&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "festival-centre---north-charleston",
      "poi_latitude": "32.9172758",
      "poi_longitude": "-80.1034683",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 610-215-7939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c7d0-7509-8f19-bb5046267630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c7d0-7509-8f19-bb5046267630",
        "storage_key": "property/6767906449167740/01a03e59-c7d0-7509-8f19-bb5046267630.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJfTHQD9SJ_ogRC_PX51JvL30",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_d01cec9a792c4493bd15d26d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Mr. Fuel Travel Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "1521 N Main St, Summerville, SC 29486, USA",
      "poi_short_description": "Fuel stop featuring a convenience store, plus a fast-food outlet, along with clean showers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-2db6-77db-9135-c6699a5f2855.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-2db6-77db-9135-c6699a5f2855",
        "storage_key": "property/6767906449167740/01a03e5b-2db6-77db-9135-c6699a5f2855.webp",
        "width": 1116,
        "height": 626
      },
      "poi_business_url": "https://locations.pilotflyingj.com/us/sc/summerville/1521-n-main-st",
      "poi_directions_map_url": "https://maps.google.com/?cid=4082195918868536829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mr-fuel-travel-center",
      "poi_latitude": "33.03876",
      "poi_longitude": "-80.142235",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 843-486-5770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c7d0-7509-8f19-bb5046267630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c7d0-7509-8f19-bb5046267630",
        "storage_key": "property/6767906449167740/01a03e59-c7d0-7509-8f19-bb5046267630.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJmbSY2teK_ogR_V21T4_fpjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "truck_stop"
    },
    {
      "id": "ec_5cce2dd925d1bf792cd9de54",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "South Carolina Department of Motor Vehicles - Ladson",
      "poi_type": "Major Employers & Offices",
      "poi_address": "135 Wimberly Dr, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-3298-767f-bd11-d34e950ae07a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-3298-767f-bd11-d34e950ae07a",
        "storage_key": "property/6767906449167740/01a03e5b-3298-767f-bd11-d34e950ae07a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://scdmvonline.com/Locations/Ladson",
      "poi_directions_map_url": "https://maps.google.com/?cid=16573943430430130933&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-carolina-department-of-motor-vehicles---ladson",
      "poi_latitude": "32.9934972",
      "poi_longitude": "-80.0951075",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 843-572-7854",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-ccd9-72c9-8dbb-cabed6f29931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-ccd9-72c9-8dbb-cabed6f29931",
        "storage_key": "property/6767906449167740/01a03e59-ccd9-72c9-8dbb-cabed6f29931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfUyZJtRh_ogR9QI1yrx5AuY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_f66c694ee371cf9a958e686f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Boeing South Carolina Delivery Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5400 Airframe Dr, North Charleston, SC 29418, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-32a8-7213-a925-bba8504c7e69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-32a8-7213-a925-bba8504c7e69",
        "storage_key": "property/6767906449167740/01a03e5b-32a8-7213-a925-bba8504c7e69.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.boeing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1818565927026470829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boeing-south-carolina-delivery-center",
      "poi_latitude": "32.8772636",
      "poi_longitude": "-80.027445",
      "poi_miles_from_property": "16.3 mi",
      "poi_walking_minutes": "5 hours 57 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 312-544-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c838-73ff-8832-72c3154726ea",
        "storage_key": "property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtVx4OUFj_ogRra8KURPYPBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_e991e35bbf475e5c6f817517",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Mercedes-Benz Vans Charleston",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8501 Palmetto Commerce Pkwy, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://mbvcharleston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6984515149643946355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercedes-benz-vans-charleston",
      "poi_latitude": "32.9638731",
      "poi_longitude": "-80.1077863",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c838-73ff-8832-72c3154726ea",
        "storage_key": "property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP9pNxeqL_ogRc5nc5oX77WA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_5a7a90dae6b577f35282b047",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Cummins Turbo Technologies",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9051 Palmetto Commerce Pkwy, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.cummins.com/components/turbochargers",
      "poi_directions_map_url": "https://maps.google.com/?cid=11508743938688989891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cummins-turbo-technologies",
      "poi_latitude": "32.9689954",
      "poi_longitude": "-80.1198148",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 843-695-2205",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c838-73ff-8832-72c3154726ea",
        "storage_key": "property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLduFtSKK_ogRw7p85KJFt58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_33730227f76a73a0d8b9f794",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Shimano",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9550 Palmetto Commerce Pkwy, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-37d4-7755-b20a-596f6cb78fec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-37d4-7755-b20a-596f6cb78fec",
        "storage_key": "property/6767906449167740/01a03e5b-37d4-7755-b20a-596f6cb78fec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.shimano.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7608264419241378652&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shimano",
      "poi_latitude": "32.9760233",
      "poi_longitude": "-80.1218828",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 843-821-9623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c838-73ff-8832-72c3154726ea",
        "storage_key": "property/6767906449167740/01a03e59-c838-73ff-8832-72c3154726ea.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV83jKj6K_ogRXEMg0i38lWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supplier"
    },
    {
      "id": "ec_dea732ad48f1deea79ad2abf",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Joint Base Charleston",
      "poi_type": "Transportation & Transit",
      "poi_address": "102 E Hill Blvd, Joint Base Charleston, SC 29404, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-34b8-773b-938f-a22d02abb32a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-34b8-773b-938f-a22d02abb32a",
        "storage_key": "property/6767906449167740/01a03e5b-34b8-773b-938f-a22d02abb32a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jbcharleston.jb.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4483304259841560535&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joint-base-charleston",
      "poi_latitude": "32.8974054",
      "poi_longitude": "-80.05202539999999",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "3 hours 58 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 843-963-1110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-ccd9-72c9-8dbb-cabed6f29931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-ccd9-72c9-8dbb-cabed6f29931",
        "storage_key": "property/6767906449167740/01a03e59-ccd9-72c9-8dbb-cabed6f29931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1z4rC-Vi_ogR1w_ag3jlNz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_fcbcc9c267d78629d219555c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "MUSC Health University Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "171 Ashley Ave, Charleston, SC 29425, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-3500-73cf-9fd7-8eed5aed3bf3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-3500-73cf-9fd7-8eed5aed3bf3",
        "storage_key": "property/6767906449167740/01a03e5b-3500-73cf-9fd7-8eed5aed3bf3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.getcare.muschealth.org/locations/sc/charleston/musc-health-university-medical-centerdep-fac139?y_source=1_MTI2NTc3MDQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12189662782097550663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "musc-health-university-medical-center",
      "poi_latitude": "32.7844359",
      "poi_longitude": "-79.9496544",
      "poi_miles_from_property": "33.3 mi",
      "poi_walking_minutes": "12 hours 4 mins",
      "poi_biking_minutes": "2 hours 6 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 843-792-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c84b-777d-9901-190f00971a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c84b-777d-9901-190f00971a77",
        "storage_key": "property/6767906449167740/01a03e59-c84b-777d-9901-190f00971a77.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJcWT8sDh6_ogRR225erdhKqk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_87e56ca98061f855fe1b453c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "Trident Technical College",
      "poi_type": "Education",
      "poi_address": "7000 Rivers Ave, North Charleston, SC 29406, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-3629-725c-8a9b-486244630071.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-3629-725c-8a9b-486244630071",
        "storage_key": "property/6767906449167740/01a03e5b-3629-725c-8a9b-486244630071.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://www.tridenttech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12635303724822809317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trident-technical-college",
      "poi_latitude": "32.9280591",
      "poi_longitude": "-80.0307641",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 843-574-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-c892-7228-9c14-11e44659d2e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-c892-7228-9c14-11e44659d2e0",
        "storage_key": "property/6767906449167740/01a03e59-c892-7228-9c14-11e44659d2e0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaftirupj_ogR5co7A8udWa8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_0fe5055c431f66c5b782030c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "poi_name": "South Carolina Ports",
      "poi_type": "Transportation & Transit",
      "poi_address": "200 Ports Authority Dr, Mt Pleasant, SC 29464, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e5b-381f-75d8-8e01-9ee6ee118983.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-381f-75d8-8e01-9ee6ee118983",
        "storage_key": "property/6767906449167740/01a03e5b-381f-75d8-8e01-9ee6ee118983.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://scspa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4328331223635565445&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-carolina-ports",
      "poi_latitude": "32.8434147",
      "poi_longitude": "-79.8780372",
      "poi_miles_from_property": "33.7 mi",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "2 hours 50 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 843-723-8651",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167740/01a03e59-ccd9-72c9-8dbb-cabed6f29931.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e59-ccd9-72c9-8dbb-cabed6f29931",
        "storage_key": "property/6767906449167740/01a03e59-ccd9-72c9-8dbb-cabed6f29931.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEa2ctWZ6_ogRhZsHv1BSETw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    }
  ],
  "office_hours": [
    {
      "id": "ec_9c6d610fde88669cb62d4df5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_184c5aad3661a904b83d3404",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_087e25e3d7ae526b7f17c9bf",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6daa0150c5eb05fd5439c24c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_fdc74a62b5d0d39649522d22",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_4de8cbbc4c5e97af2c14d79d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_b2d740b39bd9121bdf285f67",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "rating": "5",
      "name": "false",
      "text": "The Mason is HOME!! I highly recommend you stopping by!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_75168e732f6416192bc90dff",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "rating": "5",
      "name": "false",
      "text": "The Mason is truly a place that you will Love coming home too",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_000824ad6b6402d9e916a9b6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "rating": "5",
      "name": "false",
      "text": "The Mason is so clean, fresh and top-notch customer service!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_ea17bebf690ebaf56e3573a2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "rating": "5",
      "name": "false",
      "text": "Its like living on a resort !!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_a5255e82ff4d34805b4645f6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "rating": "5",
      "name": "false",
      "text": "Nice community",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_c0fe2925e046ebacb149e026",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "rating": "5",
      "name": "false",
      "text": "With just two weeks living at The Mason, I have loved every second of it. From the layout of the apartment and colors, to the friendly staff. I am very happy we moved here.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_51055b4f697a63e91a225e9b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "rating": "4",
      "name": "false",
      "text": "Los Apt son grandes modernos lujosos y bonitos.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_d7c9f12fb58385a9c152c3e5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "rating": "5",
      "name": "false",
      "text": "The Mason is Paradise , I'm so estatic and thrilled to live here . The staff is awesome .",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_19dd8d0778703de2f019da98",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "rating": "5",
      "name": "false",
      "text": "I had a couple of maintenance issues and they were on it quick. Took care of my issues the same day.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_418c92e83d8e02d1e0412ae6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "rating": "5",
      "name": "false",
      "text": "Mason is a very nice apartment setting that's suitable for all walks of life.it has been a excellent living experience for me.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_0290c78b823e14a867a5fbaa",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "rating": "5",
      "name": "false",
      "text": "Were fairly new to the complex, but we definitely enjoy living here. Comfortable and filled with amenities and the office staff is very nice and helpful.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_5684581ab645a52d42887088",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "rating": "5",
      "name": "false",
      "text": "The Mason good community to reside in. They have good policies in place to protect tenants. The properties are excellent all the way around.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_91e1fae18afcb0f6880d66e3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "rating": "5",
      "name": "false",
      "text": "The mason is a very nice place to call home the staff is outstanding",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_6043f060b06bddbd2657475d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "rating": "5",
      "name": "false",
      "text": "I love The Mason and the community that comes with living there! The amenities are great, and the apartments feel like home. I would definitely suggest this apartment complex, if someone is searching for a nice place to live.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_bd6c0c9e1881e77c8c62cb0d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "rating": "4",
      "name": "false",
      "text": "Mason, contemporary luxury resort living without the travel.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_6c028a229befac6dcc929066",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "rating": "4",
      "name": "false",
      "text": "Great place to live, friendly staff, fast maintenance service, convenient to I-26, beautiful landscaping, great floor plans.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_75632ee9b246405b15ce1f59",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "rating": "5",
      "name": "false",
      "text": "It’s Amazing And They Really Care About Their Tenants, I Love It Here.",
      "date": "false",
      "title": "Amazing"
    },
    {
      "id": "ec_c4173f5df9edac30a94cf8db",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "rating": "5",
      "name": "false",
      "text": "The apartment is very nice & the buildings and landscape are always kept in amazing condition! I would recommend The Mason to anyone looking for a nice, friendly apartment community",
      "date": "false",
      "title": "Love it here! "
    },
    {
      "id": "ec_48dc70d6e538349bdb5b72b3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "rating": "5",
      "name": "false",
      "text": "They have beautiful apartments and a picturesque pool area. The gym has all of the common equipment one might use and also a really cool smart mirror that displays workouts. The leasing office ladies are always so kind and helpful. Every week we have different food trucks that come to the community. Overall, it is a lovely place to call home. ",
      "date": "false",
      "title": "Lovely place"
    },
    {
      "id": "ec_6577a51010f3131547aa920f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "rating": "4",
      "name": "false",
      "text": "Great place for us after moving from Oregon. Maintenance staff and great and the reception team are always there to help! Wonderful swimming pool, great equipment in the gym and spacious apartments. It's been the perfect transition for us to life in South Carolina! ",
      "date": "false",
      "title": "Great place! "
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-ladson-sc",
      "search_query": "pet friendly apartments in Ladson SC",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Ladson SC",
      "h2_subtitle": "Discover Belmont's pet friendly rentals in Ladson. Perfect for pet owners seeking comfortable and convenient living.",
      "page_copy": "Looking for pet friendly apartments in Ladson, SC? Belmont provides a welcoming community perfect for you and your furry friend. Situated in the heart of Charleston County, our apartments come with ample amenities, including an on-site property manager, ensuring a seamless living experience.\n\nAt Belmont, you'll find ideal accommodations that cater not just to your needs but also to those of your pet. Enjoy features like a walk-up design, range, and ice maker, all within welcoming surroundings. Plus, living in the vibrant Summerville neighborhood means access to trails and parks perfect for walks with your pet.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Ladson SC",
      "seo_description": "Explore pet friendly apartments at Belmont in Ladson, SC. Enjoy amenities like a walk-up feature in our Summerville neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-ladson-sc",
      "search_query": "luxury apartments with pool Ladson SC",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Ladson SC",
      "h2_subtitle": "Explore Belmont's luxury living in Ladson, SC. Dive into style with our premium pool facilities and superb amenities.",
      "page_copy": "Indulge in the luxury apartments with pool in Ladson, SC at Belmont. Our community promises a distinctive living experience with top-notch amenities. Immerse yourself in comfort with premium features such as an on-site property manager, a modern range, and convenient ice maker.\n\nLocated in the charming Summerville neighborhood of Charleston County, Belmont offers not just luxurious interiors but also delightful outdoor facilities. Take advantage of our inviting pools to relax and unwind after a busy day. Experience the harmonious blend of comfort and style right in the heart of Ladson, SC.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Ladson SC",
      "seo_description": "Discover luxury poolside living at Belmont in Ladson, SC. Enjoy top amenities in Charleston County's vibrant Summerville neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "apartments-with-dog-park-summerville",
      "search_query": "apartments with dog park in Summerville",
      "category": "Amenity",
      "h1_title": "Apartments with Dog Park in Summerville",
      "h2_subtitle": "Enjoy Belmont's pet-friendly apartments with a dog park in Summerville. Perfect for dog lovers seeking community-focused living.",
      "page_copy": "Belmont offers more than just comfortable apartments; we provide pet-loving residents access to an on-site dog park in Summerville, making it a perfect home for you and your furry companion. Situated in the lively Charleston County neighborhood, our community is designed to meet both human and canine needs.\n\nOur pet-friendly amenities include an on-site property manager, walk-up accessibility, and in-unit features like a range and ice maker. Positioned ideally in the Summerville area, Belmont supports a lifestyle where you and your pet can thrive, ensuring you both have plenty of outdoor spaces to explore and play.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dog Park in Summerville",
      "seo_description": "Find your new home at Belmont with dog park access in Summerville. Perfect for pet-loving families in Charleston County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "modern-apartments-in-unit-laundry-ladson",
      "search_query": "modern apartments with in-unit laundry Ladson",
      "category": "Amenity",
      "h1_title": "Modern Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover modern living at Belmont in Ladson. Enjoy the convenience of in-unit laundry and stylish amenities in our vibrant community.",
      "page_copy": "Experience the ease of modern living at Belmont, offering modern apartments with in-unit laundry in Ladson. Our residences are designed to provide both style and convenience, catering to contemporary lifestyles. Located in the charming Charleston County neighborhood of Summerville, you'll find a community that exceeds expectations.\n\nBelmont's amenities include an on-site property manager, comfortable walk-ups, and features like a range and ice maker. Each apartment is designed to offer a seamless living experience, ensuring that doing laundry at home is comfortable and efficient. Embark on a new chapter of convenience and style at Belmont.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with In-Unit Laundry, Ladson",
      "seo_description": "Discover Belmont's modern apartments with in-unit laundry in Ladson, SC. Enjoy convenient living in the Summerville neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "spacious-apartments-walk-in-closets-charleston-county",
      "search_query": "spacious apartments with walk-in closets Charleston County",
      "category": "Amenity",
      "h1_title": "Spacious Apartments with Walk-In Closets",
      "h2_subtitle": "Explore spacious living at Belmont in Charleston County. Our apartments feature walk-in closets for enhanced comfort and storage.",
      "page_copy": "At Belmont, we redefine spacious living with our apartments featuring walk-in closets in Charleston County. Designed with ample storage and contemporary style, our homes cater to those who appreciate both functionality and comfort. Nestled in the charming Summerville area, Belmont is part of a vibrant community.\n\nOur apartments are well-equipped with convenient amenities such as a property manager on site, walk-up access, and units featuring a range and ice maker. Each residence is crafted to offer practicality without compromising on style, making storage solutions elegant and accessible. Choose Belmont for a perfect blend of space and style.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Apartments with Walk-In Closets",
      "seo_description": "Find spacious apartments with walk-in closets at Belmont in Charleston County. Perfect for stylish and functional living in Summerville.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-ladson-sc",
      "search_query": "1 bedroom apartments Ladson SC",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Ladson, SC",
      "h2_subtitle": "Discover 1 bedroom apartments at Belmont in Ladson, SC. Enjoy modern living with a range of amenities in Charleston County.",
      "page_copy": "Belmont in Ladson, SC, offers inviting 1 bedroom apartments designed for comfort and convenience in the charming community of Charleston County. Our homes are perfect for singles and couples seeking a refined living space with modern amenities.\n\nEach apartment provides features such as an on-site property manager, a functional range, and ice makers for added convenience. Located in the vibrant Summerville area, Belmont's spacious walk-ups and cozy carpeting create a welcoming environment, ensuring your living experience is both comfortable and satisfying. Choose Belmont for a warm and stylish one-bedroom retreat.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Ladson, SC",
      "seo_description": "Explore 1 bedroom apartments at Belmont in Ladson, SC, featuring modern amenities and welcoming community living in Charleston County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-summerville",
      "search_query": "2 bedroom apartments Summerville",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Summerville",
      "h2_subtitle": "Find your perfect home at Belmont with our 2 bedroom apartments in Summerville. Experience spacious living with exceptional amenities.",
      "page_copy": "At Belmont, our 2 bedroom apartments in Summerville offer the ideal balance of space and comfort, perfect for families or roommates. Located in the scenic Charleston County, these residences provide a tranquil retreat while being close to vibrant local attractions.\n\nEnjoy modern amenities that include an on-site property manager, along with practical features such as a range and an ice maker. Carpeted interior spaces and a walk-up design enhance the welcoming ambiance. Immerse yourself in a community that emphasizes convenience and quality living at Belmont, where each day feels inviting and fulfilling.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Summerville",
      "seo_description": "Discover 2 bedroom apartments at Belmont in Summerville. Enjoy spacious living with modern amenities in a serene Charleston County community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-charleston-county",
      "search_query": "3 bedroom apartments Charleston County",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments in Charleston County",
      "h2_subtitle": "Explore spacious 3 bedroom apartments at Belmont in Charleston County. Enjoy family-friendly living with expansive layouts and modern amenities.",
      "page_copy": "Belmont presents an excellent option for those seeking 3 bedroom apartments in Charleston County, perfect for larger families or those needing extra space. Nestled in the scenic Summerville area, our community combines the tranquility of suburban comfort with easy access to local attractions.\n\nEach apartment is designed with family living in mind, featuring essential amenities like an on-site property manager, expansive walk-ups, and fitted with a range and ice maker. With carpeted interiors that add a cozy touch, Belmont offers a blend of style and functionality, making it an ideal choice for a spacious home in Charleston County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments in Charleston County",
      "seo_description": "Find 3 bedroom apartments at Belmont in Charleston County, offering spacious layouts and modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "apartments-near-ladson-elementary-school",
      "search_query": "apartments near Ladson Elementary School Summerville",
      "category": "School",
      "h1_title": "Apartments Near Ladson Elementary School",
      "h2_subtitle": "Discover convenient living at Belmont, with apartments near Ladson Elementary School in Summerville. Ideal for families seeking proximity to education.",
      "page_copy": "Belmont offers the perfect residence for families looking for apartments near Ladson Elementary School in Summerville. Located within Charleston County, our community provides a welcoming environment with easy access to education and local amenities.\n\nEnjoy the benefits of living close to school while having access to modern features like an on-site property manager, spacious walk-ups, and practical appliances, including a range and ice maker. Carpeted interiors make it ideal for comfort and relaxation. Choose Belmont for a home that supports both educational pursuits and quality family living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ladson Elementary School",
      "seo_description": "Explore Belmont's proximity to Ladson Elementary School in Summerville, offering family-friendly apartments with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "belmont-apartments-near-deer-park-middle",
      "search_query": "Belmont apartments close to Deer Park Middle School",
      "category": "School",
      "h1_title": "Belmont Apartments Near Deer Park Middle",
      "h2_subtitle": "Experience convenience at Belmont, located close to Deer Park Middle School. Ideal for families prioritizing education and comfortable living.",
      "page_copy": "Choosing Belmont means opting for strategic convenience with our apartments close to Deer Park Middle School. Nestled in the heart of Charleston County, our community caters to families who value proximity to quality education and a serene living environment.\n\nBelmont offers a blend of modern amenities, including an on-site property manager and practical in-home features like a range and ice maker. With carpeted interiors and spacious walk-ups, Belmont is a place that perfectly balances comfort and accessibility, making it an ideal choice for families near Deer Park Middle School.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Belmont Apartments Near Deer Park Middle",
      "seo_description": "Live at Belmont, close to Deer Park Middle School, offering family-friendly apartments with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "charleston-county-rentals-near-rb-stall-high",
      "search_query": "Charleston County rentals near R.B. Stall High School",
      "category": "School",
      "h1_title": "Charleston County Rentals Near R.B. Stall High",
      "h2_subtitle": "Discover prime rentals in Charleston County near R.B. Stall High School, offering families both convenience and modern amenities.",
      "page_copy": "For those seeking Charleston County rentals near R.B. Stall High School, Belmont provides an ideal location. Situated in the family-friendly neighborhood of Summerville, our community offers easy access to educational facilities and an array of local services.\n\nBelmont features modern amenities such as an on-site property manager, spacious walk-up designs, and fully equipped homes with a range and ice maker. With comfortable carpeted floors, Belmont is a top choice for families desiring a home that combines proximity to education with modern comforts and conveniences.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Charleston County Rentals Near R.B. Stall High",
      "seo_description": "Explore Belmont rentals in Charleston County, near R.B. Stall High School, offering modern amenities and a family-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "summerville-apartment-homes-near-faith-christian",
      "search_query": "Summerville apartment homes by Faith Christian School",
      "category": "School",
      "h1_title": "Summerville Apartment Homes by Faith Christian",
      "h2_subtitle": "Find your perfect home at Belmont, offering apartment homes near Faith Christian School in Summerville, ideal for families and professionals alike.",
      "page_copy": "Belmont is the ideal choice for those seeking apartment homes in Summerville by Faith Christian School. Combining a convenient location with a welcoming environment, Belmont caters to families and individuals who prioritize accessibility to educational facilities.\n\nEnjoy living in spacious apartment homes equipped with modern features such as carpeted interiors, a range, and an ice maker. With an on-site property manager and the comfort of a walk-up design, Belmont delivers both convenience and community, making it a prime choice for residents wanting proximity to Faith Christian School and the amenities of Ladson.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Summerville Apartment Homes by Faith Christian",
      "seo_description": "Belmont offers Summerville apartment homes near Faith Christian School with modern amenities, perfect for families and professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "rental-homes-near-ridge-christian-academy-sc",
      "search_query": "rental homes close to Ridge Christian Academy SC",
      "category": "School",
      "h1_title": "Rental Homes Close to Ridge Christian Academy SC",
      "h2_subtitle": "Discover Belmont's rental homes conveniently located near Ridge Christian Academy SC, offering a blend of comfort and accessibility for families.",
      "page_copy": "Located in the vibrant area of Ladson, Belmont offers ideal rental homes close to Ridge Christian Academy SC. This makes it a perfect choice for families and individuals looking to live near esteemed educational institutions while enjoying the plethora of amenities Belmont provides.\n\nOur community boasts features such as an on-site property manager to cater to your needs, along with comfortable home elements like carpeted floors, a range, and an ice maker. The walk-up design further enhances the living experience, ensuring you enjoy both convenience and a high standard of living close to Ridge Christian Academy.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Homes Close to Ridge Christian Academy SC",
      "seo_description": "Explore Belmont's rental homes near Ridge Christian Academy SC, perfect for families seeking convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "apartments-near-charleston-southern-university",
      "search_query": "apartments near Charleston Southern University Ladson",
      "category": "School",
      "h1_title": "Apartments Near Charleston Southern University",
      "h2_subtitle": "Belmont offers convenient apartments near Charleston Southern University, providing residents with a perfect blend of location and lifestyle.",
      "page_copy": "Belmont is located perfectly for those seeking apartments near Charleston Southern University in Ladson, SC. Our community provides an exceptional living experience with amenities that cater to both students and professionals seeking proximity to the university and the bustling Charleston County.\n\nEnjoy the comfort of our well-equipped apartments that include features such as a range, an ice maker, and plush carpeting. With an on-site property manager, residents can enjoy seamless living experiences. Belmont's walk-up design enhances the community feel, making it a premier choice for those studying or working at Charleston Southern University.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Charleston Southern University",
      "seo_description": "Discover Belmont's apartments near Charleston Southern University in Ladson, offering modern comforts and accessible living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "belmont-rental-properties-near-trident-tech-dorchester",
      "search_query": "Belmont rental properties near Trident Technical College Dorchester Campus",
      "category": "School",
      "h1_title": "Belmont Rentals Near Trident Technical College",
      "h2_subtitle": "Explore Belmont's rental properties conveniently located close to Trident Technical College Dorchester Campus, ideal for students and professionals alike.",
      "page_copy": "Belmont offers excellent rental properties near Trident Technical College Dorchester Campus, providing a perfect option for students and working professionals in Ladson. Our community promises a welcoming environment and modern amenities that cater to diverse lifestyles.\n\nLiving at Belmont ensures you enjoy home comforts such as carpeted interiors, a convenient range, and an ice maker. With the attentive support of an on-site property manager and a community-friendly walk-up design, Belmont provides the ideal setting for those studying or working near the Dorchester Campus, enhancing your daily living experience in Charleston County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Belmont Rentals Near Trident Technical College",
      "seo_description": "Find Belmont rental properties near Trident Technical College Dorchester Campus, offering comfort and convenience in Ladson.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "charleston-county-apartments-by-trident-tech",
      "search_query": "Charleston County apartments by Trident Technical College",
      "category": "School",
      "h1_title": "Charleston County Apartments by Trident Tech",
      "h2_subtitle": "Discover Belmont's apartments conveniently located by Trident Technical College, offering a blend of convenience and modern living in Charleston County.",
      "page_copy": "Nestled in the charming neighborhood of Summerville, Belmont offers exceptional Charleston County apartments by Trident Technical College. Our community is perfect for students, faculty, and anyone seeking proximity to this bustling educational hub while enjoying the vibrancy of Ladson.\n\nAt Belmont, residents can enjoy amenities designed for comfort and convenience, including an ice maker, range, and plush carpeting. The presence of a dedicated on-site property manager ensures residents' needs are always attended to. With a unique walk-up design, our apartments provide the ideal setting for those connected with Trident Technical College, making Belmont a top choice in Charleston County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Charleston County Apartments by Trident Tech",
      "seo_description": "Explore Belmont's Charleston County apartments near Trident Technical College, offering modern living close to educational opportunities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "apartments-near-hca-healthcare-trident-hospital",
      "search_query": "apartments near HCA Healthcare Trident Hospital in Charleston County",
      "category": "Hospital",
      "h1_title": "Apartments Near HCA Healthcare Trident Hospital",
      "h2_subtitle": "Find the ideal apartment at Belmont, located conveniently near HCA Healthcare Trident Hospital in Charleston County, offering comfort and accessibility.",
      "page_copy": "Belmont presents fantastic living options for those looking for apartments near HCA Healthcare Trident Hospital in Charleston County. Our location is perfect for healthcare professionals and families seeking a balance between work and home life while staying connected to essential services.\n\nResidents at Belmont enjoy thoughtfully designed apartments with amenities such as an ice maker, a range, and comfortable carpeting. An on-site property manager ensures all residents' needs are met swiftly, allowing you to focus on what matters most. The community's walk-up design adds a friendly and accessible atmosphere, making Belmont a sought-after choice for those associated with HCA Healthcare Trident Hospital.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near HCA Healthcare Trident Hospital",
      "seo_description": "Discover Belmont's apartments near HCA Healthcare Trident Hospital, offering modern living in Charleston County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "apartments-close-to-hca-healthcare-summerville-hospital",
      "search_query": "apartments close to HCA Healthcare Summerville Hospital SC",
      "category": "Hospital",
      "h1_title": "Apartments Close to HCA Summerville Hospital",
      "h2_subtitle": "Experience the comfort of Belmont apartments, located close to HCA Healthcare Summerville Hospital in SC, blending convenience with modern amenities.",
      "page_copy": "Belmont is your ideal destination for apartments close to HCA Healthcare Summerville Hospital, SC. Perfectly situated for healthcare professionals and families, our community provides both convenience and a welcoming environment.\n\nAt Belmont, you will find modern comforts such as an ice maker and efficient range, complemented by plush carpeting. The presence of an attentive property manager on site ensures that residents enjoy prompt service and support. Our inviting walk-up design fosters a sense of community, making Belmont an excellent choice for those working at or visiting HCA Healthcare Summerville Hospital.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to HCA Summerville Hospital",
      "seo_description": "Explore Belmont's SC apartments close to HCA Healthcare Summerville Hospital, combining comfort and accessibility.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "apartments-near-musc-health-university-medical-center",
      "search_query": "apartments near MUSC Health University Medical Center Ladson",
      "category": "Hospital",
      "h1_title": "Apartments Near MUSC Health University Med",
      "h2_subtitle": "Discover Belmont's comfortable living spaces near MUSC Health University Medical Center in Ladson, offering a perfect blend of convenience and style.",
      "page_copy": "Perfectly placed in Ladson, Belmont offers apartments near MUSC Health University Medical Center, ideal for medical professionals and students seeking convenience and comfort. Enjoy a lifestyle that bridges proximity to work and home, making daily commutes a breeze.\n\nAt Belmont, our residents benefit from features like an on-site property manager, ensuring all needs are catered to efficiently. Each apartment is equipped with a modern range and ice maker, highlighted by plush carpeting throughout. With a welcoming walk-up design, Belmont establishes a vibrant community atmosphere, making it a top choice for those affiliated with MUSC Health University Medical Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near MUSC Health University Med",
      "seo_description": "Explore comfortable living at Belmont, near MUSC Health University Medical Center Ladson, SC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "apartments-near-riverfront-park-charleston",
      "search_query": "apartments near Riverfront Park Charleston County",
      "category": "Park",
      "h1_title": "Apartments Near Riverfront Park Charleston",
      "h2_subtitle": "Belmont offers convenient living near the serene Riverfront Park in Charleston County, combining urban conveniences with natural beauty.",
      "page_copy": "Located in the charming area of Ladson, Belmont provides apartments near the beautiful and serene Riverfront Park in Charleston County. This prime location is perfect for outdoor enthusiasts and those looking to enjoy natural vistas right at their doorstep.\n\nBelmont apartments come equipped with desirable amenities like an efficient range and ice maker, all maintained under the watchful eye of our dedicated property manager on site. Walk-up access and comfortable carpeting enhance the living experience, creating a blend of comfort and community. Access to Riverfront Park is a delight for residents who appreciate both the convenience of urban living and the tranquility of nature.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Riverfront Park Charleston",
      "seo_description": "Discover Belmont's convenient living near Riverfront Park in Charleston County, where urban life meets natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "belmont-apartments-by-oakbrook-nature-trail",
      "search_query": "Belmont apartments by Oakbrook Nature Trail SC",
      "category": "Park",
      "h1_title": "Belmont Apartments by Oakbrook Nature Trail",
      "h2_subtitle": "Enjoy Belmont's perfect location by Oakbrook Nature Trail, SC. Explore nature's beauty steps from your apartment in Charleston County.",
      "page_copy": "Nestled in the heart of Ladson, Belmont offers the perfect setting for those seeking apartments by Oakbrook Nature Trail, SC. Our community provides a tranquil escape with easy access to one of the area's most scenic trails, ideal for daily walks and nature lovers.\n\nResidents at Belmont enjoy amenities that complement the serene surroundings, such as plush carpeting, a range that makes meal preparation a breeze, and an on-site property manager ensuring all needs are promptly addressed. The community's walk-up design enhances the homely feel, making Belmont a premier choice for those desiring a blend of nature and comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Belmont Apartments by Oakbrook Nature Trail",
      "seo_description": "Experience Belmont living by Oakbrook Nature Trail, SC, offering modern comforts in a serene, nature-inspired setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "gahagan-park-nearby-apartments-ladson",
      "search_query": "Gahagan Park nearby apartments in Ladson",
      "category": "Park",
      "h1_title": "Gahagan Park Nearby Apartments in Ladson",
      "h2_subtitle": "Discover the comfort of Belmont, where Gahagan Park is just around the corner, offering leisure and recreation in vibrant Ladson.",
      "page_copy": "Belmont is perfectly situated for those seeking Gahagan Park nearby apartments in Ladson. Whether you're a fan of outdoor activities or simply enjoy being close to nature, Gahagan Park offers ample recreational opportunities, just a stone's throw away from our community.\n\nOur apartments boast features designed for modern living, such as a convenient range, an efficient ice maker, and cozy carpeting throughout. Managed by on-site professionals, Belmont ensures a seamless living experience. The community walk-up design fosters a welcoming atmosphere, making it a delightful place to call home right next to Gahagan Park and all it has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gahagan Park Nearby Apartments in Ladson",
      "seo_description": "Explore Belmont, offering comfort and convenience with Gahagan Park nearby in Ladson, SC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "belmont-close-to-rosebrock-park-summerville",
      "search_query": "Belmont close to Rosebrock Park Summerville",
      "category": "Park",
      "h1_title": "Belmont Close to Rosebrock Park",
      "h2_subtitle": "Experience the best of Summerville with Belmont, conveniently close to the scenic Rosebrock Park. Enjoy nature's charm at your doorstep.",
      "page_copy": "At Belmont, you'll find yourself in a prime location close to Rosebrock Park in Summerville, offering residents the perfect balance of convenience and natural beauty. With beautiful trails and lush green spaces nearby, Belmont presents a unique living experience for nature enthusiasts.\n\nEnjoy modern comforts like a fully-equipped range and an efficient ice maker within our cozy, carpeted apartments. The on-site property manager ensures that maintenance and tenant needs are consistently addressed, providing peace of mind. Belmont’s welcoming walk-up design further enhances the sense of community, making it an ideal choice for those who appreciate being near Rosebrock Park's picturesque landscapes.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Belmont Close to Rosebrock Park",
      "seo_description": "Live at Belmont, perfectly situated in Summerville and close to Rosebrock Park, offering comfort and scenic beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "ashley-river-park-adjacent-apartments-ladson",
      "search_query": "Ashley River Park adjacent apartments Ladson",
      "category": "Park",
      "h1_title": "Ashley River Park Adjacent Apartments",
      "h2_subtitle": "Discover Belmont, the ideal location with Ashley River Park just a short stroll away. Experience Ladson living close to nature.",
      "page_copy": "For those seeking Ashley River Park adjacent apartments, Belmont in Ladson is the perfect choice. This prime location offers easy access to the natural beauty and recreation that Ashley River Park provides, making it a standout feature of living in our community.\n\nBelmont caters to residents with well-thought-out amenities including a versatile range for cooking, a reliable ice maker, and luxurious carpeting throughout the apartments. The on-site property manager ensures a well-maintained and smoothly running community. With a charming walk-up design, Belmont combines comfort and outdoor appeal, offering a distinctive living experience right by Ashley River Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Ashley River Park Adjacent Apartments",
      "seo_description": "Experience life at Belmont, with Ashley River Park nearby. Enjoy the blend of comfort and natural beauty in Ladson, SC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "colonial-dorchester-site-proximity-apartments",
      "search_query": "Colonial Dorchester site proximity apartments",
      "category": "Park",
      "h1_title": "Colonial Dorchester Site Proximity Apartments",
      "h2_subtitle": "Embrace the historic charm of Ladson with Belmont, where the Colonial Dorchester State Historic Site is close by.",
      "page_copy": "Belmont offers a unique opportunity for history enthusiasts looking for Colonial Dorchester site proximity apartments. Situated in the heart of Ladson, our community provides easy access to this remarkable historic site, where you can explore the rich history and natural beauty of the area.\n\nOur apartments offer modern amenities, such as a functional range and an efficient ice maker, paired with cozy carpeting that enhances every living space. With a dedicated property manager onsite, residents enjoy a smooth and hassle-free lifestyle. Belmont's inviting walk-up design fosters a warm, communal atmosphere, perfect for those who appreciate both the conveniences of modern living and the allure of nearby historical treasures.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Colonial Dorchester Site Proximity Apartments",
      "seo_description": "Find modern amenities at Belmont, located near the Colonial Dorchester State Historic Site. Enjoy history and comfort in Ladson, SC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "wescott-park-surrounding-apartments-29456",
      "search_query": "Wescott Park surrounding apartments 29456",
      "category": "Park",
      "h1_title": "Wescott Park Surrounding Apartments",
      "h2_subtitle": "Discover the charm of Belmont, conveniently situated near Wescott Park. Enjoy community life with nature and recreation just steps away in 29456.",
      "page_copy": "For those searching for Wescott Park surrounding apartments in the 29456 area, Belmont offers an exceptional living experience. Positioned close to Wescott Park, residents can take advantage of nearby recreational activities and scenic green spaces that make this community truly special.\n\nAt Belmont, you’ll find thoughtfully designed apartments equipped with essential amenities such as a range, ice maker, and comfortable carpeting throughout. Our property manager on site ensures that you have a seamless living experience in our welcoming, community-focused environment. With easy access to both recreation and comfort, Belmont stands out as an ideal choice near Wescott Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wescott Park Surrounding Apartments",
      "seo_description": "Live at Belmont, conveniently located near Wescott Park in 29456. Enjoy recreation and comfort in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "hutchinson-square-nearby-belmont-apartments",
      "search_query": "Hutchinson Square nearby Belmont apartments",
      "category": "Park",
      "h1_title": "Belmont Apartments Near Hutchinson Square",
      "h2_subtitle": "Explore Belmont, located just a short distance from Hutchinson Square. Enjoy modern living within reach of Ladson's vibrant community hub.",
      "page_copy": "Make Belmont your home if you're drawn to Hutchinson Square nearby apartments in Ladson. Our premier community is ideally situated, offering convenient access to Hutchinson Square, a community focal point known for local events, leisurely strolls, and a vibrant atmosphere.\n\nInside Belmont, residents enjoy modern comforts, including a reliable range and ice maker, along with elegant carpeting that enhances each living space. An attentive property manager is always on site to ensure everything runs smoothly. For those preferring a touch of tradition, our walk-up design adds charm to the contemporary lifestyle offered at Belmont, making it a prime choice near Hutchinson Square.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Belmont Apartments Near Hutchinson Square",
      "seo_description": "Belmont offers modern living just steps from Hutchinson Square in Ladson. Experience a vibrant community and comfortable amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167740",
      "source": "generator",
      "page_item_url": "azalea-park-accessible-apartments-ladson",
      "search_query": "Azalea Park accessible apartments Ladson",
      "category": "Park",
      "h1_title": "Accessible Apartments Near Azalea Park",
      "h2_subtitle": "Discover the perfect blend of convenience and comfort at Belmont's accessible apartments near Azalea Park in Ladson.",
      "page_copy": "Searching for Azalea Park accessible apartments in Ladson? Look no further than Belmont, where accessibility and convenience meet charm and comfort. Situated just a short distance from Azalea Park, residents can enjoy leisurely walks and local events, making it an effortless choice for those who love outdoor spaces.\n\nBelmont features thoughtfully designed apartments with modern amenities such as a range and ice maker, complemented by plush carpeting that elevates the living experience. Our property manager on site ensures hassle-free living, creating a warm and inviting community atmosphere. Whether you're looking for relaxation or recreation, Belmont's proximity to Azalea Park offers the best of both worlds.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Accessible Apartments Near Azalea Park",
      "seo_description": "Find comfort at Belmont, offering accessible living near Azalea Park in Ladson. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ii9wcHR0clFZMHRVejZXYnhSb0g0amc9PSIsInZhbHVlIjoieTI1VmUwdGp2c2FOU3dTaWluSXUzUT09IiwibWFjIjoiNjQzYzQ0NjBkMGM2NDliNmJjYTllMjQxNTYwYjNiOTIwNjI3ZWM4ZjEzM2QyMzUwZjU3YTRlNzJiNGI5MGYxOSJ9"
    }
  ],
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ii9wcHR0clFZMHRVejZXYnhSb0g0amc9PSIsInZhbHVlIjoieTI1VmUwdGp2c2FOU3dTaWluSXUzUT09IiwibWFjIjoiNjQzYzQ0NjBkMGM2NDliNmJjYTllMjQxNTYwYjNiOTIwNjI3ZWM4ZjEzM2QyMzUwZjU3YTRlNzJiNGI5MGYxOSJ9",
  "custom_audioeye_site_id": "182f901d-2998-4dc7-8a42-8c88135b2ca4",
  "custom_audioeye_site_hash": "528ff09b2f34450bb482f90142c55496"
};

export const generatedAt = '2026-09-10T20:07:08.533Z';
